// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:15.157Z
// Property: The Leila Stockbridge (ID: 6767906449167767)
// Collections: 22 amenities, 3 floorplans (live), 28 photos, 73 POIs, 4 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167767",
  "property_external_id": "100160106",
  "property_zillow_url": "https://www.zillow.com/apartments/stockbridge-ga/novo-stockbridge/CjCB6F/",
  "property_apartments_url": "https://www.apartments.com/novo-stockbridge-stockbridge-ga/svm7c95/",
  "property_google_business_url": "https://www.google.com/maps/place/Novo+Stockbridge/data=!4m2!3m1!1s0x0:0xdc9b65ee502744ab?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "9863957055",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5605579",
  "property_status": null,
  "property_slug": "the-leila-stockbridge",
  "property_name": "The Leila Stockbridge",
  "property_website_url": "https://www.theleilastockbridge.com/",
  "property_domain": null,
  "property_address": "3151 Mt Zion Rd",
  "property_full_address": "3151 Mt Zion Rd, Stockbridge, GA 30281",
  "property_address_1": "3151 Mt Zion Rd",
  "property_address_2": null,
  "property_address_city": "Stockbridge",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30281",
  "property_address_country": "US",
  "property_address_county": "Clayton County",
  "property_neighborhood_address": "Clayton County",
  "property_address_latitude": "33.552165",
  "property_address_longitude": "-84.28811499999999",
  "property_email": null,
  "property_phone": "(770) 628-5032",
  "property_call_tracking_phone": "2294751351",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Experience a fresh take on apartment living at The Leila Stockbridge. Thoughtfully designed one, two, and three-bedroom apartment homes, resort-inspired amenities, and an unbeatable location create a community you&#039;ll love coming home to eve",
  "property_long_description": "Welcome to The Leila Stockbridge, where modern comfort meets effortless convenience.\r\nHome should be more than just where you live&mdash;it should be where you relax, recharge, and enjoy every day. At The Leila Stockbridge, you&#039;ll discover beautifully designed one, two, and three-bedroom apartment homes featuring stylish interiors, spacious layouts, granite countertops, stainless steel appliances, designer cabinetry, wood-style flooring, and the modern finishes that make coming home something to look forward to.\r\nStep outside your front door and enjoy amenities designed to complement your lifestyle. Spend sunny afternoons by the resort-style swimming pool, energize your day in the 24-hour fitness center, gather with friends around the outdoor fire pit, enjoy the scenic walking trail, or let your four-legged companion explore the bark park. Every detail has been thoughtfully designed to create a welcoming community you&#039;ll be proud to call home.\r\nPerfectly positioned in Stockbridge with quick access to I-75, shopping, dining, entertainment, parks, and major employers, The Leila Stockbridge makes it easy to enjoy everything the area has to offer while providing a peaceful retreat at the end of the day.\r\nCome experience the difference for yourself&mdash;schedule your personal tour today and discover why life is better at The Leila Stockbridge.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57c-6ba0-7398-8cd2-714e0d620d49.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and cabanas",
    "public_id": "01a0a57c-6ba0-7398-8cd2-714e0d620d49",
    "storage_key": "property/6767906449167767/01a0a57c-6ba0-7398-8cd2-714e0d620d49.webp",
    "width": 2048,
    "height": 1151
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "293",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.4914675767918",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security deposit: $500.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "Pet fee: $400.00 (non-refundable). Monthly pet rent: $20.00/month.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "http://theleilastockbridge.prospectportal.com/",
  "property_resident_portal_url": "https://theleilastockbridge.residentportal.com/auth",
  "property_apply_now_url": "http://theleilastockbridge.prospectportal.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9c4-233c-769f-bf8b-ebad38329c9c.webp",
  "property_primary_logo_media": {
    "alt_text": "The Leila Stockbridge logo.",
    "public_id": "01a0c9c4-233c-769f-bf8b-ebad38329c9c",
    "storage_key": "property/6767906449167767/01a0c9c4-233c-769f-bf8b-ebad38329c9c.webp",
    "width": 1468,
    "height": 1158
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9c4-2373-7754-93d5-c74845e48b50.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Leila Stockbridge logo.",
    "public_id": "01a0c9c4-2373-7754-93d5-c74845e48b50",
    "storage_key": "property/6767906449167767/01a0c9c4-2373-7754-93d5-c74845e48b50.webp",
    "width": 1467,
    "height": 1158
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9c3-f24e-7794-b697-cb8f505ba005.webp",
  "property_icon_media": {
    "alt_text": "Property Management Company Logo",
    "public_id": "01a0c9c3-f24e-7794-b697-cb8f505ba005",
    "storage_key": "property/6767906449167767/01a0c9c3-f24e-7794-b697-cb8f505ba005.webp",
    "width": 1339,
    "height": 1339
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9c3-f24e-7794-b697-cb8f505ba005.webp",
  "property_fav_icon_media": {
    "alt_text": "Property Management Company Logo",
    "public_id": "01a0c9c3-f24e-7794-b697-cb8f505ba005",
    "storage_key": "property/6767906449167767/01a0c9c3-f24e-7794-b697-cb8f505ba005.webp",
    "width": 1339,
    "height": 1339
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9c4-2302-7691-9dc8-abbaa27939aa.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Leila Stockbridge logo",
    "public_id": "01a0c9c4-2302-7691-9dc8-abbaa27939aa",
    "storage_key": "property/6767906449167767/01a0c9c4-2302-7691-9dc8-abbaa27939aa.webp",
    "width": 1467,
    "height": 1158
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9c4-2373-7754-93d5-c74845e48b50.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Leila Stockbridge logo.",
    "public_id": "01a0c9c4-2373-7754-93d5-c74845e48b50",
    "storage_key": "property/6767906449167767/01a0c9c4-2373-7754-93d5-c74845e48b50.webp",
    "width": 1467,
    "height": 1158
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1f2322",
  "property_secondary_color": "#1e495e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "756 - 1248",
  "property_sqft_min": "756",
  "property_sqft_max": "1248",
  "property_price_range": "$1395 - $2675",
  "property_price_min": "1395",
  "property_price_max": "2675",
  "property_available_units": 22,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIQS1Eyn59IgRq0QnUO5lm9w",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Leila Stockbridge",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": "<p><strong>Resort-inspired amenities, right at home.</strong> Move from the fitness center to the pool and sun deck, unwind by the fire pits, or take the walking trail for a fresh-air reset. A bark park adds outdoor space for pets, while apartment interiors bring the polish with stainless steel appliances, granite counters, movable islands, USB outlets, in-home washer and dryer, 9-foot ceilings, wood-style flooring, and available garages or storage.</p>",
  "property_home_floorplans_blurb": "<p><strong>Open layouts, polished finishes, easy comparisons.</strong> Browse one-, two-, and three-bedroom apartments at The Leila Stockbridge with pricing and availability made simple. Select homes feature stainless steel appliances, granite counters, 42-inch shaker-style cabinetry, movable kitchen islands, wood-style flooring, garden tubs, USB outlets, and included washers and dryers. Garages and storage closets add even more room to make the space work your way.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Leila Stockbridge in focus.</strong> Preview bright interiors with granite countertops, stainless steel appliances, shaker-style cabinetry, and wood-style flooring, then picture the community spaces that complete the experience—resort-inspired pool, sun deck, clubroom, fitness center, outdoor fire pits, and pet-friendly green space. Browse the full gallery for a closer look at the details.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Errands, escapes, and Atlanta access line up.</strong> From The Leila Stockbridge, the Mt. Zion shopping corridor and I-75 keep daily plans moving, while nearby favorites like VyStar Amphitheater at The Bridge, Pin Strikes, Newman Wetlands Center, and Arabia Mountain PATH add easy ways to unwind. Explore the neighborhood, then return to polished spaces made for a well-earned reset.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents point to the details that make daily life easier.</strong> Reviews often mention The Leila Stockbridge’s peaceful, well-kept grounds, clean surroundings, responsive maintenance, and helpful leasing team. From comfortable apartment homes to appreciated amenities and attentive service, the feedback highlights a community where care shows. Read more firsthand reviews to see what stands out most.</p>",
  "property_neighborhood_blurb": "<p><strong>Follow your map from errands to escapes.</strong> Around The Leila Stockbridge, daily stops stay simple with the Mt. Zion shopping corridor and I-75 close by, while time off can shift to concerts at VyStar Amphitheater at The Bridge, bowling and games at Pin Strikes, or fresh air at Newman Wetlands Center and the Arabia Mountain PATH system. The area feels practical without losing its south-metro Georgia character: local dining, retail convenience, green space, and routes toward Atlanta all sit within easy reach. Explore the map to see what’s nearby, then come back to polished community spaces and apartment finishes designed to make downtime feel just as considered. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that earn their place in your routine.</strong> At The Leila Stockbridge, everyday convenience comes with a polished, resort-inspired edge—morning movement in the fitness center, an easy reset by the pool and sun deck, fresh-air evenings around the fire pits, and a walking trail that gives you room to unwind without leaving the community. The bark park adds a dedicated outdoor perk for pets; see details on the <a href=\"/pet-policy\">pet policy</a>.</p><p>Inside, the features feel just as intentional. Chef-inspired kitchens pair stainless steel appliances, granite counters, tall shaker-style cabinetry, and movable islands with practical touches like USB outlets and an included washer and dryer. Add 9-foot ceilings, wood-style flooring, garden tubs, designer finishes, and available garages or storage closets, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the amenities come together.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Leila Stockbridge home?</strong> Start your application online for a modern one-, two-, or three-bedroom apartment with polished finishes, included washer and dryer, and easy access to south metro Atlanta convenience.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to The Leila Stockbridge leasing team for details on our modern one-, two-, and three-bedroom apartments near I-75, I-675, and Mt. Zion Road conveniences. We’re here to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Leila Stockbridge?</strong> Start here for quick answers about leasing, <a href=\"/floor-plans\">floor plans</a>, apartment features, and everyday living in our modern Stockbridge community. If you don’t see what you need, the leasing team is happy to help—just <a href=\"/contact-us\">reach out</a>.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that feels right from the first walkthrough.</strong> The Leila Stockbridge gives you a clear choice of one-, two-, and three-bedroom apartments, each designed with open living areas, polished kitchens, and everyday details that make settling in simple. Compare available homes by layout, pricing, and move-in timing, then picture how your furniture, routines, and favorite corners could come together.</p><p>Inside, stainless steel appliances, granite counters, 42-inch shaker-style cabinetry, movable kitchen islands, USB outlets, wood-style flooring, garden tubs, and included washers and dryers bring function and finish into balance. Need extra room beyond your front door? Available garages and storage closets add flexibility. Explore the floor plan cards below, view more <a href=\"/amenities\">apartment features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your options in person.</p>",
  "property_gallery_blurb": "<p><strong>Start with the details you can see.</strong> Browse The Leila Stockbridge photo gallery for a closer look at bright apartment interiors, polished kitchens, and inviting spaces designed with everyday comfort in mind. Picture granite counters catching the light, stainless steel appliances framed by shaker-style cabinetry, and wood-style flooring that gives each room a clean, modern finish.</p><p>Keep scrolling to see how the community comes together in Stockbridge: the resort-inspired pool and sun deck, the resident clubroom, the fitness center, outdoor fire pits, and pet-friendly green space all captured from the angles that matter. After the gallery, compare <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, explore more <a href=\"/amenities\">amenities and finishes</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Leila Stockbridge on the map.</strong><br>See available apartments and get a feel for the Mt. Zion Road location—close to I-75, I-675, everyday shopping, and an easy drive to dining, parks, entertainment, and more around Stockbridge.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living starts with easy outdoor moments.</strong> At The Leila Stockbridge, your daily routine can include a quick trip to the on-site bark park, a relaxed lap along the walking trail, or fresh air after dinner without having to plan a big outing.</p><p>Inside, easy-care wood-style flooring and included washers and dryers help keep life practical, while available garages and storage closets give you extra room for leashes, carriers, toys, and weekend gear. When you want a change of scenery, nearby Clark Community Park offers fenced dog areas and a paved trail for more room to roam.</p><p>Review the pet policy details below, then explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Stockbridge living you love.</strong> From polished one-, two-, and three-bedroom apartments to resort-style spaces made for everyday downtime, The Leila Stockbridge gives friends plenty to look forward to. Send a referral today and invite them to find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Leila Stockbridge.</strong> Manage the everyday details of apartment living in one convenient place—pay rent, submit maintenance requests, and keep your account up to date, then get back to enjoying modern Stockbridge living with the comfort and polish you expect at home.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong> In reviews of The Leila Stockbridge, recurring themes stand out: a peaceful, well-maintained setting, helpful leasing team members, and maintenance that responds quickly when something needs attention. Residents describe the community as “beautiful, peaceful, and always clean,” with praise for the care and professionalism shown by the office and maintenance teams.</p><p>You’ll also see comments about enjoying the apartment homes, appreciating the amenities, and feeling heard when questions or concerns come up. Read the reviews below for firsthand perspectives from people who have experienced daily life here.</p>",
  "property_created_at": "1789482507761",
  "property_scheduletour_blurb": "<p><strong>See The Leila Stockbridge in person.</strong> Tour modern one-, two-, and three-bedroom apartments with granite counters, stainless steel appliances, movable kitchen islands, 9-foot ceilings, and included washer and dryer—then explore the resort-style spaces that make everyday living feel effortless. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture modern Stockbridge living with polished one-, two-, and three-bedroom apartments, convenient access near I-75 and I-675, and everyday resort-style spaces designed to make home feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Take a closer look before you arrive.</strong> Explore The Leila Stockbridge through immersive virtual tours that let you move room by room, compare layouts, and get a feel for the finishes from wherever you are. Start with the clubhouse, fitness center, and pool tour to see the community’s polished social spaces, bright workout area, and resort-inspired outdoor setting. Then step inside one-, two-, and three-bedroom apartment tours to picture open living areas, modern kitchens with granite counters and shaker-style cabinetry, wood-style flooring, and everyday flow.</p><p>Use the walkthroughs to narrow your favorite <a href=\"/floor-plans\">floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see it in person.</p>",
  "property_copyright": "2026 All Rights Reserved. The Leila Stockbridge",
  "property_seo_title_home": "The Leila Stockbridge |  Apartments in Stockbridge, GA",
  "property_seo_description_home": "Welcome to The Leila Stockbridge, where modern living meets comfort. Choose from spacious floor plans and enjoy luxury amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Stockbridge, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal sanctuary at The Leila Stockbridge in Stockbridge, GA. From cozy one-bedrooms to spacious three-bedrooms, browse our diverse floor plans today!",
  "property_seo_title_amenities": "Amenities | Stockbridge, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at The Leila Stockbridge! Enjoy spacious layouts, stunning amenities, and a vibrant community. Dive into resort-style living today!",
  "property_seo_title_gallery": "Gallery | Apartments in Stockbridge, GA",
  "property_seo_description_gallery": "Discover luxury living at The Leila Stockbridge in GA! Stylish interiors and stunning amenities await. Explore our photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Leila Stockbridge Apartments",
  "property_seo_description_virtualtours": "Discover The Leila Stockbridge! Choose from spacious 1-3 bedroom apartments in a vibrant community. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | The Leila Stockbridge Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Leila Stockbridge! Use our interactive map to browse spacious floor plans and discover amenities that elevate everyday living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Stockbridge, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant life at The Leila Stockbridge! Enjoy local hotspots, parks, and dining just steps away from your one, two, or three-bedroom haven.",
  "property_seo_title_contact": "Contact Us | The Leila Stockbridge",
  "property_seo_description_contact": "Connect with The Leila Stockbridge in Stockbridge, GA! Inquire about our spacious one to three-bedroom apartments and let our leasing team assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Stockbridge, GA",
  "property_seo_description_faqs": "Find answers to your questions at The Leila in Stockbridge! Explore our amenities, floor plans, and learn why our community is perfect for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Stockbridge, GA",
  "property_seo_description_reviews": "Experience The Leila in Stockbridge, GA! Our residents share their stories of luxury living, from resort-style pools to modern amenities. Join the community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Stockbridge, GA",
  "property_seo_description_applynow": "Elevate your lifestyle at The Leila in Stockbridge, GA! Choose from stylish 1-3 bedroom apartments with top-tier amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Leila Stockbridge",
  "property_seo_description_residentaccess": "Unlock seamless living at The Leila Stockbridge! Log in to your resident portal for easy rent payment, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Leila Stockbridge",
  "property_seo_description_referafriend": "Refer a friend to The Leila Stockbridge for exclusive rewards and help build a vibrant community in Stockbridge, GA!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Leila Stockbridge",
  "property_seo_description_scheduletour": "Experience modern living at The Leila Stockbridge! Schedule a tour today and see why our vibrant community in Stockbridge, GA, is your perfect new home.",
  "property_seo_title_privacy": "Privacy Policy | The Leila Stockbridge",
  "property_seo_description_privacy": "At The Leila Stockbridge, your privacy matters. Discover how we protect your information and ensure your comfort. View our privacy policy!",
  "property_seo_title_accessibility": "Website Accessibility | The Leila Stockbridge",
  "property_seo_description_accessibility": "At The Leila Stockbridge, we champion digital inclusion, ensuring everyone can access our community resources. Join us for an accessible living experience!",
  "property_seo_title_sitemap": "Sitemap | The Leila Stockbridge",
  "property_seo_description_sitemap": "Uncover a world of comfort and style at The Leila Stockbridge. Navigate through our sitemap to find your perfect home in Stockbridge, GA!",
  "property_seo_title_thankyou": "Thank You | The Leila Stockbridge",
  "property_seo_description_thankyou": "Thank you for reaching out to The Leila Stockbridge! Your inquiry is important to us, and our team will be in touch soon for your new home journey.",
  "property_seo_title_pets": "Pet Policy | Apartments in Stockbridge, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793472564",
  "amenities": [
    {
      "id": "custom_e8263eda-43f5-45f9-9ef3-6e60e6b2de0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6cad8af5-956d-44dd-be75-4ea9c998b78c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8fe362f-e29a-4bb5-b4da-a371fe8734ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubroom",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26372bf5-560d-4b2a-8408-a32cc880719a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8015cefa-56ba-4058-9a78-ab3f79abdb52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d69a70a7-87ea-4cb4-b949-421d2b846991",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Inspired Swimming Pool with Sun Deck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27f428d2-603a-4499-b49b-2f0dceed8d9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fire Pits",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73bd095e-e983-4306-ae6b-ea7241d16444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Trail",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a4fa01a-b195-460d-ba0f-66836ad4b3ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8fee889-6206-4312-ab60-2dcaa5761da6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Garages and Storage Closets Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5110f49-601f-4145-8e6a-33f4c13fee28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "WiFi in Community Spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04ff4b35-e371-4779-9575-61b80a1361b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6932f40-3484-4502-999d-900a912a510e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "42\" Shaker‑Style Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9a34bf6-d13a-455a-8ad6-c47ef4cbc558",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Counters",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e068b921-4774-4ea9-8fc6-021e622abcc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Movable Kitchen Islands",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d49f612-43b5-4b70-9208-b952cf80d667",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "USB Outlets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a831089-6674-4a12-b310-bf75e825b159",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Garden Tubs",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5c75f59-102a-41cb-a5e1-428a81a0fb3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Washer / Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc0f864e-72e3-4c41-8f40-4b2e417cb658",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69c3b3c0-08c0-42b4-a3e9-29135f72bb19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5dae39b4-ccbb-464f-90c2-3a90a493611f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7aeb8a2b-e86a-4cea-aee3-87df984387c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "external_id": "false",
      "title": "Chef Inspired Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2291e7a1-6639-46b3-b540-1c1b54f4d48b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-837c-767f-a017-0805cbdfb249.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas at a modern apartment complex at dusk.",
        "public_id": "01a0c9fc-837c-767f-a017-0805cbdfb249",
        "storage_key": "property/6767906449167767/01a0c9fc-837c-767f-a017-0805cbdfb249.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable lounge chairs and private cabanas. Perfect for soaking up the sun or enjoying a cool evening dip.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas at a modern apartment complex at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7ecf407d-53b0-4f16-987f-583462c2e493",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-79d2-70df-9eae-f0995eabee1c.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and a plyo box.",
        "public_id": "01a0c9fc-79d2-70df-9eae-f0995eabee1c",
        "storage_key": "property/6767906449167767/01a0c9fc-79d2-70df-9eae-f0995eabee1c.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide selection of cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and a plyo box.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb9c798f-2a4d-4a6e-abb8-5e39f7f2d369",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-78bc-71fa-97af-b7e97db50c4b.webp",
      "image_media": {
        "alt_text": "Gym with weight racks, free weights, medicine balls, and cardio equipment.",
        "public_id": "01a0c9fc-78bc-71fa-97af-b7e97db50c4b",
        "storage_key": "property/6767906449167767/01a0c9fc-78bc-71fa-97af-b7e97db50c4b.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a spacious gym with a functional trainer, free weights, and cardio machines.",
      "link": "",
      "alt_text": "Gym with weight racks, free weights, medicine balls, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_863083d2-166b-43ab-a264-3b03c0bf6aae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-7262-741c-bf82-e6bf35af5031.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment with a sofa, coffee table, dining table and chairs, and a ceiling fan.",
        "public_id": "01a0c9fc-7262-741c-bf82-e6bf35af5031",
        "storage_key": "property/6767906449167767/01a0c9fc-7262-741c-bf82-e6bf35af5031.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Spacious and stylish living and dining area, perfect for relaxation and entertaining. Features modern furniture, a ceiling fan, and natural light.",
      "link": "",
      "alt_text": "Living room and dining area of an apartment with a sofa, coffee table, dining table and chairs, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0069e9de-72db-4faf-9fb8-207aa201db44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-7205-7549-9bb8-184f05c7d0dd.webp",
      "image_media": {
        "alt_text": "Lobby seating area with coffee station and modern decor.",
        "public_id": "01a0c9fc-7205-7549-9bb8-184f05c7d0dd",
        "storage_key": "property/6767906449167767/01a0c9fc-7205-7549-9bb8-184f05c7d0dd.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Welcome to our spacious and modern lobby, featuring comfortable seating, a convenient coffee station, and elegant decor.",
      "link": "",
      "alt_text": "Lobby seating area with coffee station and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac8d1ecc-e5f2-46cd-afaa-6e9b2c68a292",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-7119-764d-97d8-26d5c3c80704.webp",
      "image_media": {
        "alt_text": "Spacious lobby area with blue accent wall, seating areas, and large windows.",
        "public_id": "01a0c9fc-7119-764d-97d8-26d5c3c80704",
        "storage_key": "property/6767906449167767/01a0c9fc-7119-764d-97d8-26d5c3c80704.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring comfortable seating, modern decor, and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Spacious lobby area with blue accent wall, seating areas, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8faf612c-5e6e-4f47-8ccb-9d041b7061cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-6dcc-7375-8c23-53db3c1ac7d3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "01a0c9fc-6dcc-7375-8c23-53db3c1ac7d3",
        "storage_key": "property/6767906449167767/01a0c9fc-6dcc-7375-8c23-53db3c1ac7d3.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen, fully equipped with stainless steel appliances, ample cabinet space, and a stylish subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84d53edd-b341-4b37-8432-8d779117c96e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-7013-7569-a35d-0983d2d01770.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a0c9fc-7013-7569-a35d-0983d2d01770",
        "storage_key": "property/6767906449167767/01a0c9fc-7013-7569-a35d-0983d2d01770.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring sleek white cabinetry, a modern microwave, a spacious range, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_260da7ce-3fb4-41af-86ae-d01e955cebef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-6943-725f-8cd5-490b1608277e.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and chair.",
        "public_id": "01a0c9fc-6943-725f-8cd5-490b1608277e",
        "storage_key": "property/6767906449167767/01a0c9fc-6943-725f-8cd5-490b1608277e.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "Spacious and modern living room featuring a comfortable sofa, elegant coffee table, and accent chair, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4f2ad7b-f794-43b8-b9de-9e3b98dbbd52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-6965-71fe-9178-63b4d8f7e7cf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and an island with seating.",
        "public_id": "01a0c9fc-6965-71fe-9178-63b4d8f7e7cf",
        "storage_key": "property/6767906449167767/01a0c9fc-6965-71fe-9178-63b4d8f7e7cf.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring a large island, ample cabinet space, and sleek stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and an island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0f16e2a-7508-476b-a43e-abbc23b1d032",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-6762-70e9-ae7e-b81ef24ad170.webp",
      "image_media": {
        "alt_text": "Interior of a well-equipped apartment gym with treadmills, stationary bikes, free weights, and weight machines.",
        "public_id": "01a0c9fc-6762-70e9-ae7e-b81ef24ad170",
        "storage_key": "property/6767906449167767/01a0c9fc-6762-70e9-ae7e-b81ef24ad170.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Stay active and reach your fitness goals in our state-of-the-art resident gym, featuring cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Interior of a well-equipped apartment gym with treadmills, stationary bikes, free weights, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d15a0d8-4323-4529-adf2-d3d48599b36c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-665f-726a-bbc3-1b58f063bc26.webp",
      "image_media": {
        "alt_text": "Gym with StairMaster and Echelon bikes",
        "public_id": "01a0c9fc-665f-726a-bbc3-1b58f063bc26",
        "storage_key": "property/6767906449167767/01a0c9fc-665f-726a-bbc3-1b58f063bc26.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring StairMaster treadmills and Echelon stationary bikes.",
      "link": "",
      "alt_text": "Gym with StairMaster and Echelon bikes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_680f27a2-f252-4c4a-896b-be40883172c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-622f-71da-a1fb-68555fb1644e.webp",
      "image_media": {
        "alt_text": "Row of treadmills and other cardio machines in a bright, modern fitness center with large windows.",
        "public_id": "01a0c9fc-622f-71da-a1fb-68555fb1644e",
        "storage_key": "property/6767906449167767/01a0c9fc-622f-71da-a1fb-68555fb1644e.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, ellipticals, and stair climbers. Enjoy your workout with views of the outdoors.",
      "link": "",
      "alt_text": "Row of treadmills and other cardio machines in a bright, modern fitness center with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a388ed83-7d09-45d5-ae17-826309a43754",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-5445-72ae-9516-b3c63ee25769.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building's clubhouse with large windows and manicured landscaping.",
        "public_id": "01a0c9fc-5445-72ae-9516-b3c63ee25769",
        "storage_key": "property/6767906449167767/01a0c9fc-5445-72ae-9516-b3c63ee25769.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Discover the amenities and modern design of our apartment community, with a welcoming exterior and beautifully maintained grounds.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building's clubhouse with large windows and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60c67e40-39b1-4355-a3db-cf5710092461",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-5a8a-756e-9988-fdb7a5125e73.webp",
      "image_media": {
        "alt_text": "Outdoor ping pong table with seating and apartment buildings in the background.",
        "public_id": "01a0c9fc-5a8a-756e-9988-fdb7a5125e73",
        "storage_key": "property/6767906449167767/01a0c9fc-5a8a-756e-9988-fdb7a5125e73.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Enjoy a friendly game of ping pong on the outdoor table, located in a communal area with comfortable seating and views of the apartment buildings.",
      "link": "",
      "alt_text": "Outdoor ping pong table with seating and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9f69f5d-17b5-46eb-bb6b-b92ba73a296b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-5b11-71a7-968d-f6b019530157.webp",
      "image_media": {
        "alt_text": "Outdoor lounging area with cabanas and chaise lounges.",
        "public_id": "01a0c9fc-5b11-71a7-968d-f6b019530157",
        "storage_key": "property/6767906449167767/01a0c9fc-5b11-71a7-968d-f6b019530157.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with comfortable cabanas and chaise lounges perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor lounging area with cabanas and chaise lounges.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b313b8e-e874-4d45-9a0b-c4f85591b02b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-5df6-7083-a6fa-5478c43de410.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with dark blue couches and tables, overlooking apartment buildings.",
        "public_id": "01a0c9fc-5df6-7083-a6fa-5478c43de410",
        "storage_key": "property/6767906449167767/01a0c9fc-5df6-7083-a6fa-5478c43de410.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax in our spacious outdoor lounge area, complete with comfortable seating and tables, perfect for enjoying the fresh air and views of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Outdoor lounge area with dark blue couches and tables, overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c128df29-01cf-4d87-897d-c8e6cf19e196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-5820-710e-91f3-9062bd424318.webp",
      "image_media": {
        "alt_text": "Lounge area with blue chairs and tables",
        "public_id": "01a0c9fc-5820-710e-91f3-9062bd424318",
        "storage_key": "property/6767906449167767/01a0c9fc-5820-710e-91f3-9062bd424318.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Comfortable seating area with modern blue chairs, tables, and abstract wall art, perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Lounge area with blue chairs and tables",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d59d0e2a-63b8-4549-bac8-02d707202983",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-4f46-77ad-9805-88101fcb9704.webp",
      "image_media": {
        "alt_text": "Whirlpool washer and dryer set in a laundry room with a laundry room mat.",
        "public_id": "01a0c9fc-4f46-77ad-9805-88101fcb9704",
        "storage_key": "property/6767906449167767/01a0c9fc-4f46-77ad-9805-88101fcb9704.webp",
        "width": 1136,
        "height": 1703
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience. Laundry room features a dryer, washer, and mat for laundry day.",
      "link": "",
      "alt_text": "Whirlpool washer and dryer set in a laundry room with a laundry room mat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44bb0d27-a1a5-47e4-8e7b-09bd4f3cb2cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-51ad-75ce-9ff7-c73e3c1691db.webp",
      "image_media": {
        "alt_text": "Community lounge area with seating, coffee station, and art.",
        "public_id": "01a0c9fc-51ad-75ce-9ff7-c73e3c1691db",
        "storage_key": "property/6767906449167767/01a0c9fc-51ad-75ce-9ff7-c73e3c1691db.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating, a convenient coffee station, and modern decor.",
      "link": "",
      "alt_text": "Community lounge area with seating, coffee station, and art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d07c0f0-bbde-4ff5-a7ca-897c3d757561",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-4e72-709e-9f70-2ca4e441b0e9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a marble-tiled shower and a bathtub with a caddy.",
        "public_id": "01a0c9fc-4e72-709e-9f70-2ca4e441b0e9",
        "storage_key": "property/6767906449167767/01a0c9fc-4e72-709e-9f70-2ca4e441b0e9.webp",
        "width": 1136,
        "height": 1703
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in this modern bathroom, featuring elegant marble-patterned tiles and a convenient bathtub caddy.",
      "link": "",
      "alt_text": "Modern bathroom with a marble-tiled shower and a bathtub with a caddy.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f984491-9bfb-4865-8f74-ed1a1c6b9e09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-4db9-7037-a54b-c1a9ea2a3956.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, granite countertops, and blue accents.",
        "public_id": "01a0c9fc-4db9-7037-a54b-c1a9ea2a3956",
        "storage_key": "property/6767906449167767/01a0c9fc-4db9-7037-a54b-c1a9ea2a3956.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a spacious vanity with granite countertops and elegant blue accents.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, granite countertops, and blue accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7550eab2-c8ba-4039-ab48-6d4f9cbd233c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-436a-7538-a7c9-5a3bd962c2fc.webp",
      "image_media": {
        "alt_text": "Living room with a white couch, coffee table, and dining set.",
        "public_id": "01a0c9fc-436a-7538-a7c9-5a3bd962c2fc",
        "storage_key": "property/6767906449167767/01a0c9fc-436a-7538-a7c9-5a3bd962c2fc.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, a dining nook, and access to the outdoors.",
      "link": "",
      "alt_text": "Living room with a white couch, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f4fef61-e2f0-4da6-b5a2-b5b0638a8f9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-437b-71aa-bdc0-f2ee2004c0b2.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with island seating and sofa.",
        "public_id": "01a0c9fc-437b-71aa-bdc0-f2ee2004c0b2",
        "storage_key": "property/6767906449167767/01a0c9fc-437b-71aa-bdc0-f2ee2004c0b2.webp",
        "width": 1136,
        "height": 756
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with white cabinetry and a large island, flowing into a comfortable living room.",
      "link": "",
      "alt_text": "Modern kitchen and living room with island seating and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f829027-c5dd-482d-b760-b44134bca1e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-4379-74cd-af74-24ebbcda8fc2.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "01a0c9fc-4379-74cd-af74-24ebbcda8fc2",
        "storage_key": "property/6767906449167767/01a0c9fc-4379-74cd-af74-24ebbcda8fc2.webp",
        "width": 1136,
        "height": 1703
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_77875bc1-7860-4748-a021-05d9c6850e87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-4368-753d-8333-fc604fb5ae28.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "01a0c9fc-4368-753d-8333-fc604fb5ae28",
        "storage_key": "property/6767906449167767/01a0c9fc-4368-753d-8333-fc604fb5ae28.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in this beautifully designed kitchen. Featuring sleek white cabinetry, granite countertops, and stainless steel appliances, it's perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15c58f05-21e6-4640-bdf2-c0b1dc380626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-436d-71ca-bda2-00910c20ed63.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and artwork on the wall.",
        "public_id": "01a0c9fc-436d-71ca-bda2-00910c20ed63",
        "storage_key": "property/6767906449167767/01a0c9fc-436d-71ca-bda2-00910c20ed63.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, modern dresser, and tasteful artwork. Enjoy natural light from the large windows.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_698183c9-f831-4886-96e3-91da17e52998",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0c9fc-2d21-76d9-9e4a-6ddc109e13b1.webp",
      "image_media": {
        "alt_text": "A resort-style swimming pool with lounge chairs and cabanas.",
        "public_id": "01a0c9fc-2d21-76d9-9e4a-6ddc109e13b1",
        "storage_key": "property/6767906449167767/01a0c9fc-2d21-76d9-9e4a-6ddc109e13b1.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our stunning resort-style swimming pool, complete with comfortable lounge chairs and private cabanas.",
      "link": "",
      "alt_text": "A resort-style swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f73654a5-c2b4-444b-a54d-9a196b2e6a00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Rock N Roll Sushi",
      "poi_type": "Restaurants",
      "poi_address": "1580 Hudson Bridge Rd Ste D, Stockbridge, GA 30281, USA",
      "poi_short_description": "Trendy spot for rock-themed sushi, plus wine and cocktails in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b085-710c-b8c9-5fdd5b1bc7eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b085-710c-b8c9-5fdd5b1bc7eb",
        "storage_key": "property/6767906449167767/01a0a57a-b085-710c-b8c9-5fdd5b1bc7eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rocknrollsushi.com/locations/stockbridge-ga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2518345206637044009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-n-roll-sushi",
      "poi_latitude": "33.5043865",
      "poi_longitude": "-84.2382626",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-221-3393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0AKrGVX9IgRKaFoZ5_18iI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_a330cb4b-d1ce-475d-8cbf-ef11e8bbf252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "The Italian Oven",
      "poi_type": "Restaurants",
      "poi_address": "938 Eagles Landing Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "Pastas, pizzas, stromboli & a children's menu dished up in an easygoing restaurant.",
      "poi_long_description": "Pastas, pizzas, stromboli & a children's menu dished up in an easygoing restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-afa7-767e-85c6-31d8256b2359.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-afa7-767e-85c6-31d8256b2359",
        "storage_key": "property/6767906449167767/01a0a57a-afa7-767e-85c6-31d8256b2359.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://theitalianoven.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11486598453494996847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-italian-oven",
      "poi_latitude": "33.5135356",
      "poi_longitude": "-84.21934670000002",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-507-4827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvcoOVg5X9IgRb98eUm-YaJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3d42d161-8aad-41b4-977f-0338a71a7b24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Papi's Cuban & Caribbean Grill",
      "poi_type": "Restaurants",
      "poi_address": "1375 Rock Quarry Rd Ste 201, Stockbridge, GA 30281, USA",
      "poi_short_description": "One in a low-key local chain offering Cuban & Caribbean fare along with occasional live Latin music.",
      "poi_long_description": "One in a low-key local chain offering Cuban & Caribbean fare along with occasional live Latin music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b532-7064-a53a-db3d9cc1a705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b532-7064-a53a-db3d9cc1a705",
        "storage_key": "property/6767906449167767/01a0a57a-b532-7064-a53a-db3d9cc1a705.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://papisgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5391792909389055535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "papis-cuban--caribbean-grill",
      "poi_latitude": "33.5141849",
      "poi_longitude": "-84.2306301",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-506-9664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5XE_6ZX9IgRL8aaihV_00o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cuban_restaurant"
    },
    {
      "id": "custom_db58bba8-e6ec-46b6-bc10-9bfb9a92fad4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Mellow Mushroom Stockbridge",
      "poi_type": "Restaurants",
      "poi_address": "1410 Hudson Bridge Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_long_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b2dd-771b-9c7f-277ee95126ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b2dd-771b-9c7f-277ee95126ab",
        "storage_key": "property/6767906449167767/01a0a57a-b2dd-771b-9c7f-277ee95126ab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mellowmushroom.com/locations/ga/stockbridge/1410-hudson-bridge-rd?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=10125974546805823146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mellow-mushroom-stockbridge",
      "poi_latitude": "33.5057391",
      "poi_longitude": "-84.2333338",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-565-3966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0wkq5hX9IgRqhYCWzOwhow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6830b699-bbbe-4015-a65f-6c3c37ab25cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "KAMADO Grill & Ramen Stockbridge",
      "poi_type": "Restaurants",
      "poi_address": "3519 Hwy 138 SE, Stockbridge, GA 30281, USA",
      "poi_short_description": "Modern-décor restaurant featuring ramen, hibachi dishes, plus cocktails and a terrace.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b079-76f1-b292-a5f36ca34bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b079-76f1-b292-a5f36ca34bf6",
        "storage_key": "property/6767906449167767/01a0a57a-b079-76f1-b292-a5f36ca34bf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thekamados.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6126934921713036350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kamado-grill--ramen-stockbridge",
      "poi_latitude": "33.5506115",
      "poi_longitude": "-84.2753814",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 470-726-4112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-gm5KP59IgRPiykctk-B1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_65b5c826-940d-4193-b61a-67eac3a7ccc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "UMI Japanese Steak House",
      "poi_type": "Restaurants",
      "poi_address": "550 Eagles Landing Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "Casual spot featuring steak, chicken & seafood fired in a open-view kitchen, as well as sushi.",
      "poi_long_description": "Casual spot featuring steak, chicken & seafood fired in a open-view kitchen, as well as sushi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b0db-772b-a1d6-d53e8c29ad82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b0db-772b-a1d6-d53e8c29ad82",
        "storage_key": "property/6767906449167767/01a0a57a-b0db-772b-a1d6-d53e8c29ad82.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.umisteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406540293430553257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "umi-japanese-steak-house",
      "poi_latitude": "33.5141991",
      "poi_longitude": "-84.2115656",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-389-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtexfMhdX9IgRqarva9sHqnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_28252202-bb4d-4921-8b8d-dd0c8ec403a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Tony's at Brentwood",
      "poi_type": "Restaurants",
      "poi_address": "1005 Brentwood Pkwy #113, Stockbridge, GA 30281, USA",
      "poi_short_description": "Casual joint in a strip mall serving New York-style pizza & classic Italian mains, plus beer & wine.",
      "poi_long_description": "Casual joint in a strip mall serving New York-style pizza & classic Italian mains, plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-aa76-723b-b7a6-48f7ccd10cc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-aa76-723b-b7a6-48f7ccd10cc9",
        "storage_key": "property/6767906449167767/01a0a57a-aa76-723b-b7a6-48f7ccd10cc9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tonysatbrentwood.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3206156162955853719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tonys-at-brentwood",
      "poi_latitude": "33.5270175",
      "poi_longitude": "-84.2676041",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-389-5628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8BpVdRX9IgRl79pEwuOfiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_79955827-bcb1-4292-98f0-8364faf92213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Bench Warmers Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "1375 Rock Quarry Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Relaxed, sports-themed eatery known for its burgers, wings and beers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-aa64-7547-8fa9-14ecc0102b0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-aa64-7547-8fa9-14ecc0102b0f",
        "storage_key": "property/6767906449167767/01a0a57a-aa64-7547-8fa9-14ecc0102b0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://benchwarmersgrill.com/stockbridge?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=13848357751120157790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bench-warmers-sports-grill",
      "poi_latitude": "33.5140495",
      "poi_longitude": "-84.2305374",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-565-7034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5XE_6ZX9IgRXlwLvgBAL8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_8e74cbca-9c21-4083-862e-156c6699ee86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "The Bridge Grill and Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "1481 Hudson Bridge Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Laid-back bar and barbecue grill dishing up fresh oysters, fish and chips, burgers, wings and other American staples accompanied by cold beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-aa95-7125-b9fb-4f2f2d979222.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-aa95-7125-b9fb-4f2f2d979222",
        "storage_key": "property/6767906449167767/01a0a57a-aa95-7125-b9fb-4f2f2d979222.webp",
        "width": 1191,
        "height": 854
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=413714926646816042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bridge-grill-and-oyster-bar",
      "poi_latitude": "33.5033305",
      "poi_longitude": "-84.2373429",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-814-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl-RHzZlX9IgRKm0PqYjPvQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_65e1e587-35a9-4f13-832b-6cc866f9480a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Sarah's Country Cooking",
      "poi_type": "Restaurants",
      "poi_address": "1060 Eagles Landing Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "A cafeteria-style setup of homespun Southern fare such as pork chops & fried green tomatoes.",
      "poi_long_description": "A cafeteria-style setup of homespun Southern fare such as pork chops & fried green tomatoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ae85-73de-9c56-09c2920f4810.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ae85-73de-9c56-09c2920f4810",
        "storage_key": "property/6767906449167767/01a0a57a-ae85-73de-9c56-09c2920f4810.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://sarahscc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17331371430075915903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sarahs-country-cooking",
      "poi_latitude": "33.5115039",
      "poi_longitude": "-84.2245539",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-289-8958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJifKoxRFX9IgRf14HeH1mhfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_71948c12-8a16-4444-aa8b-842ef950af94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Disruption BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1334 GA-138, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b6dd-72b3-bbe3-8008ba395ac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b6dd-72b3-bbe3-8008ba395ac9",
        "storage_key": "property/6767906449167767/01a0a57a-b6dd-72b3-bbe3-8008ba395ac9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://disruptionbbq.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15380259065825318628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "disruption-bbq",
      "poi_latitude": "33.5576047",
      "poi_longitude": "-84.1698057",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-782-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61j3W6tR9IgR5Nb_2yGocdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d798c1d8-8913-4df4-bc6c-518d99300533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Frontera Mexican Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "3607 GA-138, Stockbridge, GA 30281, USA",
      "poi_short_description": "Relaxed restaurant offering a wide menu of standard Mexican fare, plus cocktails & lunch deals.",
      "poi_long_description": "Relaxed restaurant offering a wide menu of standard Mexican fare, plus cocktails & lunch deals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b7fb-75fc-a470-a6353b2bcb16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b7fb-75fc-a470-a6353b2bcb16",
        "storage_key": "property/6767906449167767/01a0a57a-b7fb-75fc-a470-a6353b2bcb16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://myfrontera.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5264562630044589758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frontera-mexican-kitchen",
      "poi_latitude": "33.5523891",
      "poi_longitude": "-84.27321839999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-474-1540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJETKRfZ_49IgRvp6atdF7D0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4e5bbf7d-32f3-43fa-8dc0-d88e949f04a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "GABINOS MEXICAN GRILL",
      "poi_type": "Restaurants",
      "poi_address": "1745 Rock Quarry Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-b89b-719e-98a2-8072ac08a688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-b89b-719e-98a2-8072ac08a688",
        "storage_key": "property/6767906449167767/01a0a57a-b89b-719e-98a2-8072ac08a688.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.gabinosmexgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3742367804461965708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabinos-mexican-grill",
      "poi_latitude": "33.5111275",
      "poi_longitude": "-84.2304382",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-488-0039",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5Al1KBX9IgRjGHQs7CP7zM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_977e2fd9-b73a-45fd-b18c-ebeeb27239da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Krispy Kreme",
      "poi_type": "Restaurants",
      "poi_address": "120 Hwy 138 W, Stockbridge, GA 30281, USA",
      "poi_short_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_long_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-bb01-773a-a1a4-4725dcca23b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-bb01-773a-a1a4-4725dcca23b0",
        "storage_key": "property/6767906449167767/01a0a57a-bb01-773a-a1a4-4725dcca23b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://site.krispykreme.com/ga/stockbridge/120-highway-138-w?y_source=1_MTE4OTc4ODUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15626245905978523424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krispy-kreme",
      "poi_latitude": "33.5542545",
      "poi_longitude": "-84.2633847",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-565-6317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfalS5hhW9IgRIH_ALtyT29g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_72e1df4e-ce1d-4876-b06b-4af19c98f8f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "3867 GA-138, Stockbridge, GA 30281, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-2bc1-72bb-8183-ee21a3e09903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-2bc1-72bb-8183-ee21a3e09903",
        "storage_key": "property/6767906449167767/01a0a578-2bc1-72bb-8183-ee21a3e09903.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/location-detail/2656/golden-corral-highway-138-se/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2656",
      "poi_directions_map_url": "https://maps.google.com/?cid=8964673729521400165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "33.5544832",
      "poi_longitude": "-84.2647061",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-389-4830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7920-777e-933a-ddec8796781f",
        "storage_key": "property/6767906449167767/01a0a578-7920-777e-933a-ddec8796781f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRJyrFQtwYkRZTlml0LraHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_254f1039-5b06-4b93-af62-05790b79b936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Chevron",
      "poi_type": "Transportation & Transit",
      "poi_address": "3441 Mt Zion Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15297627278244885144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron",
      "poi_latitude": "33.5509126",
      "poi_longitude": "-84.2811153",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-289-4756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0d-71e9-a86c-498efd75550e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0d-71e9-a86c-498efd75550e",
        "storage_key": "property/6767906449167767/01a0a57a-fe0d-71e9-a86c-498efd75550e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzqsjpf49IgRmLIckvUWTNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_55809e9b-38c1-4bab-a1ed-8cd93ba204e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5095 Mt Zion Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ba8c-7406-b647-cb9312655c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ba8c-7406-b647-cb9312655c5f",
        "storage_key": "property/6767906449167767/01a0a57a-ba8c-7406-b647-cb9312655c5f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/stockbridge-ga-pharmacies/5095-mount-zion-pkwy-stockbridge-ga-30281/storeid=7064?WT.mc_id=LS_GOOGLE_RX_7064",
      "poi_directions_map_url": "https://maps.google.com/?cid=16056572922869284115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.5433655",
      "poi_longitude": "-84.28370500000001",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-507-0576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0c-768c-9cb4-80657976748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0c-768c-9cb4-80657976748b",
        "storage_key": "property/6767906449167767/01a0a57a-fe0c-768c-9cb4-80657976748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZFTypH49IgRE33HgQBo1N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4ae1d8e9-c890-4b36-8d27-d46afba5664f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5600 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Home, electronics and sporting goods retailer stocking groceries and furniture, plus clothing and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-bc2b-760d-ae6c-65478275d88a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-bc2b-760d-ae6c-65478275d88a",
        "storage_key": "property/6767906449167767/01a0a57a-bc2b-760d-ae6c-65478275d88a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/745-stockbridge-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18059337924882332606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.5534721",
      "poi_longitude": "-84.2555587",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-389-1709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7950-777c-8416-078f59e42eed",
        "storage_key": "property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMdb_NxZW9IgRvvtZAymon_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f242090e-2b6d-4b20-918a-da59848fd05d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1750 Hudson Bridge Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-bc56-72a1-be5f-3d4600afd86d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-bc56-72a1-be5f-3d4600afd86d",
        "storage_key": "property/6767906449167767/01a0a57a-bc56-72a1-be5f-3d4600afd86d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/stockbridge/spivey-junction/011/00493?cid=loc_01100493_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8363452458119731454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.5031868",
      "poi_longitude": "-84.2442504",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-507-7732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7923-77ea-8479-9a7526b689e7",
        "storage_key": "property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ZecI5RX9IgR_hgY_rLzEHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_51f740d2-c5d4-4297-825f-30dd737a8ba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Publix Super Market at Eagles Landing",
      "poi_type": "Shopping & Retail",
      "poi_address": "909 Eagles Landing Pkwy #300, Stockbridge, GA 30281, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-be70-72a5-95d7-88799f416a00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-be70-72a5-95d7-88799f416a00",
        "storage_key": "property/6767906449167767/01a0a57a-be70-72a5-95d7-88799f416a00.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=547&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=7506805824155156660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-eagles-landing",
      "poi_latitude": "33.510525",
      "poi_longitude": "-84.21991",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-389-6130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7923-77ea-8479-9a7526b689e7",
        "storage_key": "property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9Xo1Q1X9IgRtACa0h-ILWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_60ae4718-e3b0-4df8-9215-c0ca740158fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "5420 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c07b-753c-8784-b80b553c0cb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c07b-753c-8784-b80b553c0cb5",
        "storage_key": "property/6767906449167767/01a0a57a-c07b-753c-8784-b80b553c0cb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/stockbridge/5420-north-henry-blvd/l939",
      "poi_directions_map_url": "https://maps.google.com/?cid=3255113967124942039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.550974",
      "poi_longitude": "-84.255325",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7923-77ea-8479-9a7526b689e7",
        "storage_key": "property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zKb7T1W9IgR1wzlIeh8LC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8c81c61e-453c-487f-becc-7d65c4d1d52a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Food Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4709 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Discount grocery-store chain selling meat, produce & brand-name goods since 1975.",
      "poi_long_description": "Discount grocery-store chain selling meat, produce & brand-name goods since 1975.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c135-7488-b488-57f02236c155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c135-7488-b488-57f02236c155",
        "storage_key": "property/6767906449167767/01a0a57a-c135-7488-b488-57f02236c155.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shop.fooddepot.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12113632128313183524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-depot",
      "poi_latitude": "33.5435095",
      "poi_longitude": "-84.2339506",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-474-7225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7923-77ea-8479-9a7526b689e7",
        "storage_key": "property/6767906449167767/01a0a578-7923-77ea-8479-9a7526b689e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_cR5VtW9IgRJM3daz1EHKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c2f97bc1-ca83-47de-8729-097da1c3ac75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Hudson Bridge Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c5a1-77f8-9e70-abd8e5f18a71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c5a1-77f8-9e70-abd8e5f18a71",
        "storage_key": "property/6767906449167767/01a0a57a-c5a1-77f8-9e70-abd8e5f18a71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1855+hudson+bridge+rd-stockbridge-ga-30281/id=6209",
      "poi_directions_map_url": "https://maps.google.com/?cid=13888840344914714273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.4995187",
      "poi_longitude": "-84.24583129999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-565-0648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2uBmJNX9IgRoV7BHLUSv8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_130bf6a6-38d9-469c-84a3-cbe14af0fcbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "5627 N Henry Blvd Ste 100, Stockbridge, GA 30281, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c2a4-76b8-b2bf-37e0e6344738.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c2a4-76b8-b2bf-37e0e6344738",
        "storage_key": "property/6767906449167767/01a0a57a-c2a4-76b8-b2bf-37e0e6344738.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ga/stockbridge/4030",
      "poi_directions_map_url": "https://maps.google.com/?cid=9494451885421976603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "33.5544291",
      "poi_longitude": "-84.2608029",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-615-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7950-777c-8416-078f59e42eed",
        "storage_key": "property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpx-7MxhW9IgRG1ydn68Rw4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_a5bbad38-4d86-43d9-a4b5-d985d6eec77e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2034 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-2ddb-7084-84fb-ea16da8cb540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-2ddb-7084-84fb-ea16da8cb540",
        "storage_key": "property/6767906449167767/01a0a578-2ddb-7084-84fb-ea16da8cb540.webp",
        "width": 1256,
        "height": 786
      },
      "poi_business_url": "https://www.homedepot.com/l/Morrow/GA/Morrow/30260/114?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5361682806427823992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.5640941",
      "poi_longitude": "-84.3223172",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-478-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7950-777c-8416-078f59e42eed",
        "storage_key": "property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG24RLzv59IgReC9z4xqGaEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e8de36c2-41ce-406a-85a9-4512806c689c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "AppleGate Academy & Preschool",
      "poi_type": "Education",
      "poi_address": "3050 Mt Zion Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.applegateacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7894059806243247193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applegate-academy--preschool",
      "poi_latitude": "33.5545193",
      "poi_longitude": "-84.2909525",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-565-7311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp9vg9b_49IgRWVTRupFVjW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_0ca9a0fe-327a-4994-a34e-7c2f6a9c7cef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "ABC Early Learning Academy",
      "poi_type": "Education",
      "poi_address": "110 N Park Trail, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c2ef-72ac-b372-d506753a761f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c2ef-72ac-b372-d506753a761f",
        "storage_key": "property/6767906449167767/01a0a57a-c2ef-72ac-b372-d506753a761f.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://abcearlylearning.com/stockbridge-childcare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2378144924554963781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abc-early-learning-academy",
      "poi_latitude": "33.513536",
      "poi_longitude": "-84.23139379999999",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-389-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz83JbBME9YgRRSt_fDXeACE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3a45b401-da2d-4555-affc-2f035f22b378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Cotton Indian Elementary School",
      "poi_type": "Education",
      "poi_address": "1201 Old Conyers Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c587-74fd-84f8-05bcdcb9aa23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c587-74fd-84f8-05bcdcb9aa23",
        "storage_key": "property/6767906449167767/01a0a57a-c587-74fd-84f8-05bcdcb9aa23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://schoolwires.henry.k12.ga.us/cie/site/default.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4249002286169217886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cotton-indian-elementary-school",
      "poi_latitude": "33.5616405",
      "poi_longitude": "-84.2011162",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-474-9983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsUgAsaRW9IgRXlvwLBF99zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f4c0ad89-38c8-40a8-be78-14a6b4dad3be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Stockbridge Middle School",
      "poi_type": "Education",
      "poi_address": "533 Old Conyers Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c83e-7355-8ae8-45faaa69b01e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c83e-7355-8ae8-45faaa69b01e",
        "storage_key": "property/6767906449167767/01a0a57a-c83e-7355-8ae8-45faaa69b01e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sms.henry.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13422695372191292105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stockbridge-middle-school",
      "poi_latitude": "33.5577853",
      "poi_longitude": "-84.2214989",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-474-5710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-x7f6I5W9IgRydq9E1P-Rro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ac4ab59e-48a9-46d1-a20b-1447902fdada",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Stockbridge High School",
      "poi_type": "Education",
      "poi_address": "1151 Old Conyers Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c7e1-703c-9a56-3e9f70525269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c7e1-703c-9a56-3e9f70525269",
        "storage_key": "property/6767906449167767/01a0a57a-c7e1-703c-9a56-3e9f70525269.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://schoolwires.henry.k12.ga.us/shs/site/default.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5002929806396694498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stockbridge-high-school",
      "poi_latitude": "33.56406820000001",
      "poi_longitude": "-84.202681",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-474-8747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl3u0raRW9IgR4h99-ib6bUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ba320933-2913-49da-b42a-f8a14fcd2c1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Austin Road Elementary School",
      "poi_type": "Education",
      "poi_address": "50 Austin Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://are.henry.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9756019785464961345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-road-elementary-school",
      "poi_latitude": "33.606725",
      "poi_longitude": "-84.1840739",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-389-6556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGUmwzspT9IgRQVlSJk5YZIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1f397722-5ad6-49a3-a6e8-563dd4c56751",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Austin Road Middle School",
      "poi_type": "Education",
      "poi_address": "100 Austin Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://arm.henry.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5734374739323288311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "austin-road-middle-school",
      "poi_latitude": "33.6093788",
      "poi_longitude": "-84.1838337",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 770-507-5407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlfX6MYdT9IgR93pWgnGXlE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_54233c14-81e2-4956-8c79-250fa21fc5a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Stockbridge Elementary School",
      "poi_type": "Education",
      "poi_address": "4617 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ses.henry.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16726053268738872081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stockbridge-elementary-school",
      "poi_latitude": "33.5431828",
      "poi_longitude": "-84.2311692",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-474-8743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXx27JllW9IgRERNxWdTgHug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_35d5e0ca-ab78-4617-8b12-a007acd82ac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Smith Barnes Elementary School",
      "poi_type": "Education",
      "poi_address": "147 Tye St, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://sbe.henry.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9977686177268596440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smith-barnes-elementary-school",
      "poi_latitude": "33.5373167",
      "poi_longitude": "-84.2362814",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-474-4066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK50UTlBW9IgR2H5r1Lbcd4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fa32bebe-a508-45a3-b607-cef7152ef83f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Clayton State University",
      "poi_type": "Education",
      "poi_address": "2000 Clayton State Blvd, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-2bca-74b7-9001-0c9b80355310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-2bca-74b7-9001-0c9b80355310",
        "storage_key": "property/6767906449167767/01a0a578-2bca-74b7-9001-0c9b80355310.webp",
        "width": 1200,
        "height": 572
      },
      "poi_business_url": "https://www.clayton.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1480539289079976038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clayton-state-university",
      "poi_latitude": "33.5949194",
      "poi_longitude": "-84.32953909999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-466-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf6Gb0tz-9IgRZhCfoaPuixQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9ca66e16-b2c3-4be3-a6cd-ea3c86feaa26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Stockbridge Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "4650 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c52b-75d8-b7cd-3dbd11869d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c52b-75d8-b7cd-3dbd11869d61",
        "storage_key": "property/6767906449167767/01a0a57a-c52b-75d8-b7cd-3dbd11869d61.webp",
        "width": 1136,
        "height": 640
      },
      "poi_business_url": "https://stockbridgeamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3774369267404007437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stockbridge-amphitheater",
      "poi_latitude": "33.5452145",
      "poi_longitude": "-84.2310334",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-389-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUyViKBX9IgRDWjE6tlAYTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_8e10ad8c-a391-44a0-beb2-73076642916b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Panola Mountain State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2620 Georgia 155 SW, Stockbridge, GA 30281, USA",
      "poi_short_description": "Known for its granite mountain, this park offers hiking, 2 fishing lakes, a nature center & camping.",
      "poi_long_description": "Known for its granite mountain, this park offers hiking, 2 fishing lakes, a nature center & camping.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-c6b2-7388-bb07-9cdf3654e6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-c6b2-7388-bb07-9cdf3654e6e8",
        "storage_key": "property/6767906449167767/01a0a57a-c6b2-7388-bb07-9cdf3654e6e8.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.gastateparks.org/PanolaMountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=18302068810322645492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panola-mountain-state-park",
      "poi_latitude": "33.6339527",
      "poi_longitude": "-84.1587457",
      "poi_miles_from_property": "13.7",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 770-389-7801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJofYplHFT9IgR9JEJTp0C_v0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_274f05de-74fd-406b-a804-02a755de55c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Yule Forest",
      "poi_type": "Entertainment",
      "poi_address": "3565 GA-155 N, Stockbridge, GA 30281, USA",
      "poi_short_description": "Tree farm offering choose-and-cut options, plus seasonal attractions such as a pumpkin patch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ce28-7585-a264-14bfb534049f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ce28-7585-a264-14bfb534049f",
        "storage_key": "property/6767906449167767/01a0a57a-ce28-7585-a264-14bfb534049f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://yuleforest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13546341195399147607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yule-forest",
      "poi_latitude": "33.547361",
      "poi_longitude": "-84.13844979999999",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 770-954-9356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnyJYOp9R9IgRV7ABrotF_rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_78ba43ac-76cf-4a14-b0e5-18bd47bb2c6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Spivey Hall",
      "poi_type": "Entertainment",
      "poi_address": "2000 Clayton State Blvd, Morrow, GA 30260, USA",
      "poi_short_description": "A music venue that hosts top international jazz & classical artists, known for its superb acoustics.",
      "poi_long_description": "A music venue that hosts top international jazz & classical artists, known for its superb acoustics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-cdfc-751d-8c76-da1b61d5845c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-cdfc-751d-8c76-da1b61d5845c",
        "storage_key": "property/6767906449167767/01a0a57a-cdfc-751d-8c76-da1b61d5845c.webp",
        "width": 1280,
        "height": 364
      },
      "poi_business_url": "https://www.spiveyhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10249382828349295007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spivey-hall",
      "poi_latitude": "33.5929041",
      "poi_longitude": "-84.32908789999999",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-466-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-dQvsb-9IgRn4m_-mAfPY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_53a3fca0-63cb-465f-97f2-f0ed2e35ff10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "AMC Southlake 24",
      "poi_type": "Entertainment",
      "poi_address": "7065 Mt Zion Cir, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d033-73c9-8025-889dd72b034b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d033-73c9-8025-889dd72b034b",
        "storage_key": "property/6767906449167767/01a0a57a-d033-73c9-8025-889dd72b034b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/atlanta/amc-southlake-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17026612037318711478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-southlake-24",
      "poi_latitude": "33.5632772",
      "poi_longitude": "-84.3294514",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-473-0719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0d-71e9-a86c-4ca4de62c4dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0d-71e9-a86c-4ca4de62c4dd",
        "storage_key": "property/6767906449167767/01a0a57a-fe0d-71e9-a86c-4ca4de62c4dd.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80wF2jv59IgRtpjF5G-tSuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_157de59b-4032-4362-8594-07a7ea48ea99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "EchoPark Speedway",
      "poi_type": "Entertainment",
      "poi_address": "1500 Tara Pl, Hampton, GA 30228, USA",
      "poi_short_description": "Sprawling complex with seasonal NASCAR racing, local track events, driving classes & campgrounds.",
      "poi_long_description": "Sprawling complex with seasonal NASCAR racing, local track events, driving classes & campgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d106-7703-87da-de7912d1592e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d106-7703-87da-de7912d1592e",
        "storage_key": "property/6767906449167767/01a0a57a-d106-7703-87da-de7912d1592e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.echoparkspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12290914195028995819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "echopark-speedway",
      "poi_latitude": "33.3860647",
      "poi_longitude": "-84.31658379999999",
      "poi_miles_from_property": "16.5",
      "poi_walking_minutes": "6 hours 2 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 877-926-7849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtw8CzDL09IgR626CH1cZkqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_bee9396a-b5b3-43d9-addf-555e7706b85f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Spivey Splash Water Park",
      "poi_type": "Entertainment",
      "poi_address": "2300 Hwy 138 SE, Jonesboro, GA 30236, USA",
      "poi_short_description": "Relaxed space offering water slides, a lazy river and a kiddie pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-3872-752a-90f4-5012aa67b92b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-3872-752a-90f4-5012aa67b92b",
        "storage_key": "property/6767906449167767/01a0a578-3872-752a-90f4-5012aa67b92b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.spiveysplash.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10197488550364441821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spivey-splash-water-park",
      "poi_latitude": "33.5243589",
      "poi_longitude": "-84.3108235",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-603-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ3dxwn59IgR3eyV1c7BhI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_7aa62d91-5e2a-4735-aaf5-d32291df729a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Arabia Mountain National Heritage Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3350 Klondike Rd, Stonecrest, GA 30038, USA",
      "poi_short_description": "2,550-acre area offering miles of multiuse trails, fishing lakes, ranger-led tours & historic sites.",
      "poi_long_description": "2,550-acre area offering miles of multiuse trails, fishing lakes, ranger-led tours & historic sites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d15e-779c-a487-ce862b487fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d15e-779c-a487-ce862b487fdf",
        "storage_key": "property/6767906449167767/01a0a57a-d15e-779c-a487-ce862b487fdf.webp",
        "width": 1189,
        "height": 1080
      },
      "poi_business_url": "http://arabiaalliance.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=69493463553891376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arabia-mountain-national-heritage-area",
      "poi_latitude": "33.6678417",
      "poi_longitude": "-84.1196447",
      "poi_miles_from_property": "17.5",
      "poi_walking_minutes": "6 hours 25 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 404-998-8384",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHXA1i0it9YgRMFxX2e_j9gA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_c5f6524a-ce68-4cef-8697-d808f4c44561",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Henry County Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "37 Lemon St, McDonough, GA 30253, USA",
      "poi_short_description": "Performing arts center offering a clean venue, comfortable seating, ballet recitals, performances and classes, plus a friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d13d-707a-8a84-763a93d23a11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d13d-707a-8a84-763a93d23a11",
        "storage_key": "property/6767906449167767/01a0a57a-d13d-707a-8a84-763a93d23a11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://henry.k12.ga.us/site/Default.aspx?PageID=88",
      "poi_directions_map_url": "https://maps.google.com/?cid=2040669286564162659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-county-performing-arts-center",
      "poi_latitude": "33.448886",
      "poi_longitude": "-84.134649",
      "poi_miles_from_property": "14.7",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 770-914-7477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fhm_vBa9IgRY-y0eefpURw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ee867595-ba69-400f-98f6-84facf3b1e29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Heritage Park Veterans Museum",
      "poi_type": "Entertainment",
      "poi_address": "101 Lake Dow Rd, McDonough, GA 30252, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d5b9-7335-960a-7dc86f3b1266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d5b9-7335-960a-7dc86f3b1266",
        "storage_key": "property/6767906449167767/01a0a57a-d5b9-7335-960a-7dc86f3b1266.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://heritageparkveteransmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12302793683115897328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-park-veterans-museum",
      "poi_latitude": "33.440367",
      "poi_longitude": "-84.1201311",
      "poi_miles_from_property": "15.7",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 943-600-8906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0d-71e9-a86c-471850ee382a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0d-71e9-a86c-471850ee382a",
        "storage_key": "property/6767906449167767/01a0a57a-fe0d-71e9-a86c-471850ee382a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWHf_Nxa9IgR8PEK-6tNvKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_712e7f9f-a431-4d7a-a520-b333f575f6ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Piedmont Henry",
      "poi_type": "Health and Wellness",
      "poi_address": "1133 Eagles Landing Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-40aa-77dd-bc5a-61f8c677ae35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-40aa-77dd-bc5a-61f8c677ae35",
        "storage_key": "property/6767906449167767/01a0a578-40aa-77dd-bc5a-61f8c677ae35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-henry-hospital?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4NzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16988970070758721226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-henry",
      "poi_latitude": "33.5111408",
      "poi_longitude": "-84.2271275",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-792f-75fc-b35f-50be59ac9122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-792f-75fc-b35f-50be59ac9122",
        "storage_key": "property/6767906449167767/01a0a578-792f-75fc-b35f-50be59ac9122.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBduprw5X9IgRygZRl0TyxOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2b6e2411-ba77-42db-8dfe-d021ab146d06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Piedmont QuickCare - Stockbridge",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Hudson Bridge Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d5ba-748f-89a8-8c7fe4879013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d5ba-748f-89a8-8c7fe4879013",
        "storage_key": "property/6767906449167767/01a0a57a-d5ba-748f-89a8-8c7fe4879013.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.care.piedmont.org/locations/location-details/practice/1308?utm_source=directorylisting&utm_medium=seo&utm_campaign=10221&y_source=1_MTI5OTY5NTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17598076538685687777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-quickcare---stockbridge",
      "poi_latitude": "33.4994913",
      "poi_longitude": "-84.24579539999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-732-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm57topNX9IgR4Qd_kl_tOPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b23e555b-66db-4219-8c67-5b35af0eaabd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Care Runners EMS",
      "poi_type": "Health and Wellness",
      "poi_address": "240 Corporate Center Dr A, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d8c3-745d-83e4-c662431f9307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d8c3-745d-83e4-c662431f9307",
        "storage_key": "property/6767906449167767/01a0a57a-d8c3-745d-83e4-c662431f9307.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://carerunnersems.com/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=13193396230018740375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "care-runners-ems",
      "poi_latitude": "33.5062407",
      "poi_longitude": "-84.2205656",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 470-507-4946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSNQLc1b9IgRl7A-N_hbGLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_0976934e-e304-4b56-922a-79726eb1bab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Moye's Pharmacy - Stockbridge",
      "poi_type": "Health and Wellness",
      "poi_address": "4467 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d4d4-74f3-b8b6-e6876fe6dba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d4d4-74f3-b8b6-e6876fe6dba4",
        "storage_key": "property/6767906449167767/01a0a57a-d4d4-74f3-b8b6-e6876fe6dba4.webp",
        "width": 650,
        "height": 300
      },
      "poi_business_url": "http://moyespharmacy.com/stockbridge/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13229426440811395478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moyes-pharmacy---stockbridge",
      "poi_latitude": "33.5432092",
      "poi_longitude": "-84.22515750000001",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-474-0704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0c-768c-9cb4-80657976748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0c-768c-9cb4-80657976748b",
        "storage_key": "property/6767906449167767/01a0a57a-fe0c-768c-9cb4-80657976748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4V3lX_ZW9IgRljm5YkFdmLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_77e673a0-9c5c-4e4c-aa7d-2a2d05544c05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3885 GA-138, Stockbridge, GA 30281, USA",
      "poi_short_description": "Spacious gym featuring a range of workout equipment and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-3ad3-73fb-9918-049ea8b0f9b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-3ad3-73fb-9918-049ea8b0f9b7",
        "storage_key": "property/6767906449167767/01a0a578-3ad3-73fb-9918-049ea8b0f9b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/stockbridge-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11286276040342686619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.5553036",
      "poi_longitude": "-84.2660131",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-489-7453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVLPNsdX9IgRm8ug7ULooJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_78e2b3f9-ca12-48bb-ab01-6c21dca6de1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Workout Anytime Stockbridge",
      "poi_type": "Health and Wellness",
      "poi_address": "3658 Hwy 138 SE, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d7d5-748a-af1f-9d57b46407ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d7d5-748a-af1f-9d57b46407ea",
        "storage_key": "property/6767906449167767/01a0a57a-d7d5-748a-af1f-9d57b46407ea.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://workoutanytime.com/location/stockbridge/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7121161169687129035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "workout-anytime-stockbridge",
      "poi_latitude": "33.5517082",
      "poi_longitude": "-84.27210989999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 678-369-3658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQrUhJ_49IgRy6uBs1py02I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6640c6b3-db81-41fb-a58b-61351e7d271f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "HOTWORX - Stockbridge, GA (Stockbridge Village)",
      "poi_type": "Health and Wellness",
      "poi_address": "3550 Hwy 138 SE, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-d83f-779b-bb9b-7cf98e8e4832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-d83f-779b-bb9b-7cf98e8e4832",
        "storage_key": "property/6767906449167767/01a0a57a-d83f-779b-bb9b-7cf98e8e4832.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/stockbridge-stockbridgevillage?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1493624639468451216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---stockbridge-ga-stockbridge-village",
      "poi_latitude": "33.5496685",
      "poi_longitude": "-84.27237939999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-508-5711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpSuzMjD59IgRkLVJL7JruhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9cb73155-25f2-4e9a-9d32-c443d88e9a01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Southern Lotus Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "2139 GA-155 N, McDonough, GA 30252, USA",
      "poi_short_description": "Warm studio with a friendly community offering classes for all skill levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-da7a-7145-8db6-3cf38f8f610a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-da7a-7145-8db6-3cf38f8f610a",
        "storage_key": "property/6767906449167767/01a0a57a-da7a-7145-8db6-3cf38f8f610a.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://southernlotusyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7670095071686673661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-lotus-yoga",
      "poi_latitude": "33.508375",
      "poi_longitude": "-84.1402749",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 678-961-5937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnRirSvZa9IgR_cRbbdSmcWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_c2e95627-a01d-4989-9011-0e6654a8f1f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Cochran Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "305 E Atlanta Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Park with baseball fields, a walking path, playground, and picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-dea2-74d4-9a51-4df61427fb6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-dea2-74d4-9a51-4df61427fb6e",
        "storage_key": "property/6767906449167767/01a0a57a-dea2-74d4-9a51-4df61427fb6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1269393163019619249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cochran-park",
      "poi_latitude": "33.55297",
      "poi_longitude": "-84.2337708",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-288-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVVU5GZW9IgRsQsYMlvKnRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7c2aea21-414c-4e63-b799-ee5432281f09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "J. P. MOSELEY PARK",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1041 Millers Mill Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Park with a playground, picnic shelter, sports fields, walking trail, and disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-dc8a-7473-9c41-252e1a6ca2cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-dc8a-7473-9c41-252e1a6ca2cc",
        "storage_key": "property/6767906449167767/01a0a57a-dc8a-7473-9c41-252e1a6ca2cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.henrycountyga.gov/389/Parks?contentId=f2560594-cc91-4ea6-bf0d-34240944a326&contentId=1f9a93d3-d555-4c60-b795-91bc26f95f2f",
      "poi_directions_map_url": "https://maps.google.com/?cid=14697099701393980814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-p-moseley-park",
      "poi_latitude": "33.532483",
      "poi_longitude": "-84.1627625",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-288-7311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_8Z7xhR9IgRjn0WUk-W9ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_523dece4-02fd-44cc-b79c-cf3bbb38bfa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "106 Jennings Way, Stockbridge, GA 30281, USA",
      "poi_short_description": "Picnic sites, multiple playgrounds, basketball courts & a walking track feature at this scenic spot.",
      "poi_long_description": "Picnic sites, multiple playgrounds, basketball courts & a walking track feature at this scenic spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-df4c-7508-808d-443cdee78393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-df4c-7508-808d-443cdee78393",
        "storage_key": "property/6767906449167767/01a0a57a-df4c-7508-808d-443cdee78393.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3463829902299479533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "33.5368641",
      "poi_longitude": "-84.2298277",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-389-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQk6rVdW9IgR7b3vqPH-ETA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c38c5e85-bd77-4bb8-889e-23961f118b91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Reeves Creek Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Stockbridge, GA 30281, USA",
      "poi_short_description": "Paved, shaded, dog-friendly trail with a workout corner at its entrance and small bridges.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-e53e-72dc-9858-cee3808caba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-e53e-72dc-9858-cee3808caba9",
        "storage_key": "property/6767906449167767/01a0a57a-e53e-72dc-9858-cee3808caba9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17626692491420812048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reeves-creek-trail",
      "poi_latitude": "33.5346642",
      "poi_longitude": "-84.2461004",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe45-71f9-927d-d80057bd00ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe45-71f9-927d-d80057bd00ef",
        "storage_key": "property/6767906449167767/01a0a57a-fe45-71f9-927d-d80057bd00ef.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJP-T3XVJW9IgREMMuRG6XnvQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_cf145e2b-2dec-4b15-8d55-8426b5446ead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Fairview Recreation Center Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "35 Austin Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Clean indoor recreation center featuring classes, after-school programs and more, plus a basketball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-dde2-765a-bdda-4a65755ce8b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-dde2-765a-bdda-4a65755ce8b1",
        "storage_key": "property/6767906449167767/01a0a57a-dde2-765a-bdda-4a65755ce8b1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.henrycountyga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17759256439880256176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairview-recreation-center-camp",
      "poi_latitude": "33.608454",
      "poi_longitude": "-84.1874284",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 770-288-7314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5YbkvXhU9IgRsIohtqONdfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_cc650b23-837b-4280-b72d-badb1444375a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Gardner",
      "poi_type": "Transportation & Transit",
      "poi_address": "Gardner Park, 268 E Atlanta Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-e594-7641-b2f5-833b0daca0d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-e594-7641-b2f5-833b0daca0d2",
        "storage_key": "property/6767906449167767/01a0a57a-e594-7641-b2f5-833b0daca0d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2725024399087945792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gardner",
      "poi_latitude": "33.5517803",
      "poi_longitude": "-84.2337723",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe42-702f-a7ea-a35546659b4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe42-702f-a7ea-a35546659b4c",
        "storage_key": "property/6767906449167767/01a0a57a-fe42-702f-a7ea-a35546659b4c.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJxzWqplpX9IgRQMjoz0A70SU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_5ded0dab-abe0-4c57-b413-f874a45ff66d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Clark Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "111 Davis Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "11+ acres offering modern play structures, a paved walking path, picnic areas & a grill.",
      "poi_long_description": "11+ acres offering modern play structures, a paved walking path, picnic areas & a grill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-4930-767a-9751-ca04ae43d735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-4930-767a-9751-ca04ae43d735",
        "storage_key": "property/6767906449167767/01a0a578-4930-767a-9751-ca04ae43d735.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stockbridgega.org/places",
      "poi_directions_map_url": "https://maps.google.com/?cid=4588128670713782063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clark-community-park",
      "poi_latitude": "33.5497583",
      "poi_longitude": "-84.23611210000001",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-389-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWAWd11W9IgRLx-ukbdOrD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d1fd39f1-03a5-4166-a5a0-18121ce5fc6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Richardson Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3779 Union Church Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "Park featuring facilities for tennis, a playground, and separate areas for large and small dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-e607-751d-aed0-577a1d1f42bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-e607-751d-aed0-577a1d1f42bc",
        "storage_key": "property/6767906449167767/01a0a57a-e607-751d-aed0-577a1d1f42bc.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "https://rockdalecountyga.gov/county-departments/general-services/parks-and-trails/richardson-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1556339318797335295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richardson-dog-park",
      "poi_latitude": "33.5894079",
      "poi_longitude": "-84.1381506",
      "poi_miles_from_property": "13.7",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJscZHIZxT9IgR_3rjVl06mRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_f616a24f-50c9-419b-8880-6ebbb38e00e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "South Rockdale Community Park, Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3909 E Fairview Rd SW, Stockbridge, GA 30281, USA",
      "poi_short_description": "Riverside outdoor space featuring long tracks for walking, biking and horses, plus playgrounds and a pavilion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-e717-739b-8012-1b6a9d6d0a5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-e717-739b-8012-1b6a9d6d0a5f",
        "storage_key": "property/6767906449167767/01a0a57a-e717-739b-8012-1b6a9d6d0a5f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1973554283929031983&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-rockdale-community-park-playground",
      "poi_latitude": "33.6059474",
      "poi_longitude": "-84.11571390000002",
      "poi_miles_from_property": "14.4",
      "poi_walking_minutes": "5 hours 16 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794c-777e-ade4-4f9328d0f57b",
        "storage_key": "property/6767906449167767/01a0a578-794c-777e-ade4-4f9328d0f57b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJccnncmRS9IgRL1WKNip5Yxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d17bee82-40fe-44bc-885d-7cfa8fd37592",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "BrandsMart USA",
      "poi_type": "Shopping & Retail",
      "poi_address": "I-75 & State Road, 4000 Mt Zion Pkwy #138, Stockbridge, GA 30281, USA",
      "poi_short_description": "Retailer with an extensive selection of home appliances & electronics, including TVs & computers.",
      "poi_long_description": "Retailer with an extensive selection of home appliances & electronics, including TVs & computers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-eb63-745c-9198-483510be5cb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-eb63-745c-9198-483510be5cb8",
        "storage_key": "property/6767906449167767/01a0a57a-eb63-745c-9198-483510be5cb8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.brandsmartusa.com/store/ga/stockbridge/4000-mount-zion-pkwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=15964784869080055903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brandsmart-usa",
      "poi_latitude": "33.547203",
      "poi_longitude": "-84.2847366",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-389-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-7950-777c-8416-078f59e42eed",
        "storage_key": "property/6767906449167767/01a0a578-7950-777c-8416-078f59e42eed.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX5Z5tJb49IgRX0AM3UBPjt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7ac1cef0-a36b-4754-9ce9-5b4e35fbbd64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Stockbridge Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Stockbridge, GA 30236, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=640010992433832530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stockbridge-park-and-ride",
      "poi_latitude": "33.54817000000001",
      "poi_longitude": "-84.27899000000001",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe44-7268-bf1f-66c6f909585c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe44-7268-bf1f-66c6f909585c",
        "storage_key": "property/6767906449167767/01a0a57a-fe44-7268-bf1f-66c6f909585c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WCVk5n49IgRUiJdUJvG4Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a1e82361-d827-448a-b87d-81cf18f35f6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Motel 6 Stockbridge, GA Hwy 138 W",
      "poi_type": "Transportation & Transit",
      "poi_address": "619 GA-138, Stockbridge, GA 30281, USA",
      "poi_short_description": "Straightforward rooms in a casual budget hotel offering complimentary breakfast & Wi-Fi.",
      "poi_long_description": "Straightforward rooms in a casual budget hotel offering complimentary breakfast & Wi-Fi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ea49-76c8-b6ce-618d46f021f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ea49-76c8-b6ce-618d46f021f1",
        "storage_key": "property/6767906449167767/01a0a57a-ea49-76c8-b6ce-618d46f021f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.motel6.com/property/motel-stockbridge-ga-georgia-us-293162?lid=Local_Milestone&travelAgentNumber=TA001305&corporatePlusNumber=CP792N5W&utm_source=google%20my%20business&utm_medium=organic%20listing&utm_campaign=visit%20website&utm_content=global",
      "poi_directions_map_url": "https://maps.google.com/?cid=17477849495274607124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "motel-6-stockbridge-ga-hwy-138-w",
      "poi_latitude": "33.5463815",
      "poi_longitude": "-84.27499480000002",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 678-274-3287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe25-72b7-9c86-07d25860d3ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe25-72b7-9c86-07d25860d3ff",
        "storage_key": "property/6767906449167767/01a0a57a-fe25-72b7-9c86-07d25860d3ff.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ01kOBpz49IgRFFKVq4PLjfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "motel"
    },
    {
      "id": "custom_4510b45d-6cbf-4240-a582-6cb6a5678719",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ebc6-71be-8d33-210217efbca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ebc6-71be-8d33-210217efbca3",
        "storage_key": "property/6767906449167767/01a0a57a-ebc6-71be-8d33-210217efbca3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe45-71f9-927d-dccff1e49c9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe45-71f9-927d-dccff1e49c9c",
        "storage_key": "property/6767906449167767/01a0a57a-fe45-71f9-927d-dccff1e49c9c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_05039d06-a45b-4dcc-9ede-f25e48485938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Mt Zion Rd @ Cameron Landing Dr",
      "poi_type": "Transportation & Transit",
      "poi_address": "Georgia 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3984356159683282150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mt-zion-rd--cameron-landing-dr",
      "poi_latitude": "33.551067",
      "poi_longitude": "-84.27883899999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe44-7268-bf1f-66c6f909585c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe44-7268-bf1f-66c6f909585c",
        "storage_key": "property/6767906449167767/01a0a57a-fe44-7268-bf1f-66c6f909585c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJf93zQ5j49IgR5sSPNNFGSzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c7c8cd13-a78a-487c-9694-4b49cbf98bb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Stockbridge City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4640 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ef4f-776d-844f-cf1666c81905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ef4f-776d-844f-cf1666c81905",
        "storage_key": "property/6767906449167767/01a0a57a-ef4f-776d-844f-cf1666c81905.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stockbridgega.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1693425432463517581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stockbridge-city-hall",
      "poi_latitude": "33.5447962",
      "poi_longitude": "-84.2313894",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-389-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0d-71e9-a86c-471850ee382a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0d-71e9-a86c-471850ee382a",
        "storage_key": "property/6767906449167767/01a0a57a-fe0d-71e9-a86c-471850ee382a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cmMU1ZX9IgRjaeZa3VBgBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_87036f1e-320f-4a73-ad8e-33d06956d5af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Henry County Schools District Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33 N Zack Hinton Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-ede7-717d-a7f0-5955abd33948.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-ede7-717d-a7f0-5955abd33948",
        "storage_key": "property/6767906449167767/01a0a57a-ede7-717d-a7f0-5955abd33948.webp",
        "width": 1280,
        "height": 859
      },
      "poi_business_url": "http://www.henry.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8671751715609959852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-county-schools-district-office",
      "poi_latitude": "33.448419",
      "poi_longitude": "-84.1380667",
      "poi_miles_from_property": "14.4",
      "poi_walking_minutes": "5 hours 19 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 770-957-6601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-791f-724d-b47b-5cb6010c8700",
        "storage_key": "property/6767906449167767/01a0a578-791f-724d-b47b-5cb6010c8700.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3arKK_da9IgRrN1QjT1AWHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3503973-81ff-4316-aac6-56617285f31f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Henry County Government Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Henry County Administration Building, 140 Henry Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-f279-75bb-924c-51c120d0687e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-f279-75bb-924c-51c120d0687e",
        "storage_key": "property/6767906449167767/01a0a57a-f279-75bb-924c-51c120d0687e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.co.henry.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11068444187166427040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-county-government-office",
      "poi_latitude": "33.4237737",
      "poi_longitude": "-84.1661907",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 30 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-288-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-fe0d-71e9-a86c-471850ee382a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57a-fe0d-71e9-a86c-471850ee382a",
        "storage_key": "property/6767906449167767/01a0a57a-fe0d-71e9-a86c-471850ee382a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3xz5sdb9IgRoMdKWFgDm5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_37df50a3-5007-4c67-945e-8ac68211ea9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Delta World HQ Main Entrance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1030 Delta Blvd, Atlanta, GA 30354, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-f1b2-7117-a5b7-06c97df3b7ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-f1b2-7117-a5b7-06c97df3b7ad",
        "storage_key": "property/6767906449167767/01a0a57a-f1b2-7117-a5b7-06c97df3b7ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.delta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11228272524889868168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delta-world-hq-main-entrance",
      "poi_latitude": "33.6571986",
      "poi_longitude": "-84.4226372",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Wowj0T99IgRiMdWF1_W0ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_69fbe72c-06b8-4ef4-ba42-420b6cd95d48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Goya Foods oficina",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4005 Haworth Pkwy, McDonough, GA 30253, USA",
      "poi_short_description": "Distribution service and warehouse where truckers praise the staff and say they are unloaded quickly.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-f4bd-7058-b13b-71d0154a4a7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-f4bd-7058-b13b-71d0154a4a7a",
        "storage_key": "property/6767906449167767/01a0a57a-f4bd-7058-b13b-71d0154a4a7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.goya.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1980122966161951924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goya-foods-oficina",
      "poi_latitude": "33.4114131",
      "poi_longitude": "-84.17351670000001",
      "poi_miles_from_property": "15.8",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 770-898-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUa2B-lb9IgRtAytuVjPehs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "custom_b722a172-e52a-436f-8562-ffb996613a71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "poi_name": "Vulcan Materials Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3925 N Henry Blvd, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-f6a9-73cd-8969-2132159b6ec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57a-f6a9-73cd-8969-2132159b6ec6",
        "storage_key": "property/6767906449167767/01a0a57a-f6a9-73cd-8969-2132159b6ec6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.vulcanmaterials.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3966565376648487624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vulcan-materials-company",
      "poi_latitude": "33.5312342",
      "poi_longitude": "-84.2103831",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-474-9197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-794b-74e5-9246-9bec27901180",
        "storage_key": "property/6767906449167767/01a0a578-794b-74e5-9246-9bec27901180.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8Pn7-hW9IgRyCJ_vTESDDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_61fb7ea905699db2e34174b3",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2483376ba78b72dc1855877b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1d72835c8816142190354773",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7c9b0e96987d7a75fe0b074e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8602d504e0bc335f75e4e7e3",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e315e5fb91d0e970da013d0c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4ebf435124fc3517283b869d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "rating": "5",
      "name": "Janee Davenport",
      "text": "I love living at Novo Stockbridge. 10/10 it’s beautiful, peaceful, and always clean. The leasing staff really all are so nice respectful and helpful solving our concerns in quick and timely manner. However, the manager Monica is amazing!! She has such a sweet soul and her energy positivity is infectious! She was able to turn a terrible day around for me after one quick chat. The support received by them is greatly appreciated and an experience I believe anyone would enjoy.",
      "date": "2026-09-03",
      "title": "false"
    },
    {
      "id": "ec_4c9a2454f812ddff22915378",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "rating": "5",
      "name": "Lavantay Hudson",
      "text": "I literally love my unit. I’ve been staying here now for six months and the amenities are great. I literally have no outside bills besides my Georgia Power bill and my rental assurance so the amenities here are just French kiss, The associates in the rent office are so helpful, generous, kind, and understanding.. Even down to the maintenance guys I put a work order in one day they literally were at my door less than an hour to fix my problem.. I recommend these apartments to everyone I know.",
      "date": "2026-06-15",
      "title": "false"
    },
    {
      "id": "ec_afd91095d88a563b127182c4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "rating": "4",
      "name": "Life Of Miria",
      "text": "My experience living at NOVO Stockbridge has been truly excellent since the day I moved in  going on two years ago . The community is well-maintained but  what really sets this place apart is the incredible management team. I would like to specifically commend the consistent professionalism and genuine support provided by Ms. Ashley, Dominique, and Ms. Monica; they go above and beyond to ensure residents feel heard and valued. While I understand that individual experiences may vary, my time here has been consistently positive, and I am very happy with my decision to call this community home.\n\nI want to recognize the amazing Maintenance Supervisor Promis and the entire maintenance team at Novo Stockbridge Apartments. They are always professional, respectful, and quick to respond whenever a maintenance request is submitted. Every repair I’ve needed has been completed efficiently, and they always make sure the job is done right the first time.",
      "date": "2026-07-13",
      "title": "false"
    },
    {
      "id": "ec_21f839bdcd749edc3e4f047a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "rating": "5",
      "name": "Rae Fraser",
      "text": "I have been living at Novo since they opened. The new management is doing an amazing job. Monika is absolutely friendly, it is always a pleasure to speak with her and she always addresses all my concerns. Living here has been a true joy and I truly appreciate all the changes the new management team is making.",
      "date": "2026-06-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_34674329c7aaf0bc0946cb3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-bb3e-721a-8416-b3aa7e06850c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57a-bb3e-721a-8416-b3aa7e06850c",
        "storage_key": "property/6767906449167767/01a0a57a-bb3e-721a-8416-b3aa7e06850c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse, Fitness Center, Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gHFJU5huKkb"
    },
    {
      "id": "ec_2e75b82b9fe8e0c227f73634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-aed9-733c-a53e-cc6319110f45.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57a-aed9-733c-a53e-cc6319110f45",
        "storage_key": "property/6767906449167767/01a0a57a-aed9-733c-a53e-cc6319110f45.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 756SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=82T17w3ThJv"
    },
    {
      "id": "ec_0ba74fbaece91498f5d62eff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-9a7c-75af-81be-055e0dfe1229.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57a-9a7c-75af-81be-055e0dfe1229",
        "storage_key": "property/6767906449167767/01a0a57a-9a7c-75af-81be-055e0dfe1229.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1176SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KYnJAqQkFeP"
    },
    {
      "id": "ec_7c465f05ee11e8543e0b42a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-9884-7126-9c42-baa45e99c1d8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57a-9884-7126-9c42-baa45e99c1d8",
        "storage_key": "property/6767906449167767/01a0a57a-9884-7126-9c42-baa45e99c1d8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 756SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PZbGFdS6eHA"
    },
    {
      "id": "ec_60c43998fd74bd89d8cb692c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167767/01a0a57a-bb76-741b-9c8f-3576a4ce4591.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57a-bb76-741b-9c8f-3576a4ce4591",
        "storage_key": "property/6767906449167767/01a0a57a-bb76-741b-9c8f-3576a4ce4591.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1248SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8uyFMyRrtzw"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0cfa6-0f17-7382-afe7-4ec8ca4a9dc6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Leila Stockbridge Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-stockbridge-ga",
      "search_query": "apartments with in-unit laundry Stockbridge GA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Stockbridge GA",
      "h2_subtitle": "Experience the convenience of in-unit laundry at The Leila Stockbridge. Discover modern apartments in Stockbridge, GA, with premium amenities.",
      "page_copy": "Enjoy the ease of living at The Leila Stockbridge, where each apartment comes with the convenience of in-unit laundry. Located in the heart of Stockbridge, GA, our community offers thoughtfully designed spaces featuring 9' ceilings and premium amenities like stainless steel appliances and 42\" shaker-style cabinetry. Perfect for those who appreciate style and substance, The Leila Stockbridge guarantees a hassle-free lifestyle.\n\nAlongside in-unit washers and dryers, residents benefit from detached garages for extra storage and easy parking. Our luxury apartments blend modern design with functionality, ensuring residents enjoy every moment at home. Make laundry days a breeze and experience the comfort of our well-appointed residences in Stockbridge, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Stockbridge GA",
      "seo_description": "Find Stockbridge GA apartments with in-unit laundry at The Leila Stockbridge. Enjoy modern amenities and spacious designs in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-clayton-county",
      "search_query": "dog-friendly apartments with bark park in Clayton County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Bark Park",
      "h2_subtitle": "Discover dog-friendly living at The Leila Stockbridge. Enjoy our Clayton County community offering a dedicated bark park for your furry friends.",
      "page_copy": "Welcome to The Leila Stockbridge, where pets are as welcome as our residents. Nestled in the vibrant Clayton County, our dog-friendly apartments feature a delightful bark park, ensuring your furry friends have plenty of space to roam and play. This pet-loving community is designed with you and your pets in mind, complemented by high-quality amenities like stainless steel appliances and comfortable 9' ceilings in every home.\n\nAt The Leila Stockbridge, we believe pets are family, too. Our community offers spaces that cater to both human and canine needs, promoting a balanced and enjoyable lifestyle for everyone. With in-unit washer and dryer, and detached garages, convenience is at your fingertips. Embrace the perfect blend of comfort and pet-friendly living in beautiful Clayton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Bark Park",
      "seo_description": "Explore dog-friendly apartments with a bark park at The Leila Stockbridge in Clayton County. Enjoy premium pet-friendly amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-30281",
      "search_query": "luxury apartments with resort-style pool 30281",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Resort-Style Pool",
      "h2_subtitle": "Indulge in luxury living at The Leila Stockbridge. Explore our 30281 community with a stunning resort-style pool and premium amenities.",
      "page_copy": "Discover refined living at The Leila Stockbridge, the premier destination for those seeking luxury apartments in the 30281 area. Our stunning resort-style pool offers residents a perfect place to relax and soak up the sun, providing a true retreat right at home. The beautifully landscaped pool area enhances the elegance of our community and gives you an unparalleled living experience.\n\nEach apartment is designed with premium features including stainless steel appliances, spacious 9' ceilings, and sleek 42\" shaker-style cabinetry. With conveniences such as in-unit washers and dryers and available detached garages, our apartments elevate your lifestyle in Stockbridge, GA. Retreat to a vibrant community where luxury and leisure meet in perfect harmony.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Resort-Style Pool in 30281",
      "seo_description": "Experience The Leila Stockbridge's luxury apartments with a resort-style pool in 30281. Enjoy modern amenities and elegant design.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "stockbridge-apartments-fitness-center",
      "search_query": "state-of-the-art fitness center in Stockbridge apartments",
      "category": "Amenity",
      "h1_title": "Stockbridge Apartments with Fitness Center",
      "h2_subtitle": "Stay active at The Leila Stockbridge, where our state-of-the-art fitness center is ready for you. Discover the best in Stockbridge apartment living.",
      "page_copy": "The Leila Stockbridge offers a transformative living experience in Stockbridge, GA, featuring a state-of-the-art fitness center designed to keep you motivated and healthy. Whether you're lifting weights or engaging in heart-pumping cardio, our fully equipped gym provides all the tools you need just steps away from your front door. Whatever your fitness goals, we make it convenient to stay fit and active.\n\nOur luxury apartments complement your active lifestyle with premium features like in-unit laundry facilities, modern stainless steel appliances, and considerable 9' ceilings. Additional amenities include detached garages and elegant 42\" shaker-style cabinetry to enhance your living experience. Join a community where health and luxury come together in perfect synergy in Stockbridge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stockbridge Apartments with Fitness Center",
      "seo_description": "Explore The Leila Stockbridge's state-of-the-art fitness center in Stockbridge. Enjoy modern amenities in our luxury apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "stockbridge-apartments-stainless-steel-appliances",
      "search_query": "apartments with stainless steel appliances in Stockbridge",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Enjoy modern living at The Leila Stockbridge. Our Stockbridge apartments feature sleek stainless steel appliances in every home.",
      "page_copy": "At The Leila Stockbridge, contemporary style meets everyday convenience with our stylish stainless steel appliances that adorn each apartment. Located in the heart of Stockbridge, our homes are thoughtfully designed to offer both elegance and functionality, ensuring your kitchen becomes a culinary haven.\n\nBeyond the sophisticated kitchens, our apartments provide 9' ceilings, in-unit washer and dryer, and beautiful 42\" shaker-style cabinetry. With additional offerings such as optional detached garages, The Leila Stockbridge provides a comfortable and modern living experience where every detail matters. Discover why our community is the ideal place to call home in Stockbridge, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stockbridge Apartments with Stainless Steel Appliances",
      "seo_description": "Find your perfect home at The Leila Stockbridge with top-of-the-line stainless steel appliances in Stockbridge. Enjoy modern amenities and elegant design.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-stockbridge-ga",
      "search_query": "1 bedroom apartments Stockbridge GA",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Stockbridge, GA",
      "h2_subtitle": "Discover inviting 1 bedroom apartments at The Leila Stockbridge. Located in Stockbridge, GA, our homes offer comfort and modern amenities.",
      "page_copy": "Welcome to The Leila Stockbridge, where our 1 bedroom apartments provide an ideal blend of comfort and style in Stockbridge, GA. These thoughtfully designed residences are perfect for those seeking a cozy yet sophisticated living space equipped with premium amenities. Revel in the contemporary feel of stainless steel appliances, complemented by the charm of 9' ceilings and elegant 42\" shaker-style cabinetry.\n\nIn each apartment, the convenience of an in-unit washer and dryer ensures daily chores are a breeze, while the option of detached garages offers additional storage solutions. Whether you're relaxing at home or taking advantage of our community amenities, The Leila Stockbridge invites you to experience the best of Stockbridge living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Stockbridge, GA",
      "seo_description": "Explore 1 bedroom apartments in Stockbridge, GA at The Leila Stockbridge. Enjoy modern amenities and comfortable living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "2-bedroom-apartment-clayton-county",
      "search_query": "2 bedroom apartment Clayton County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Clayton County",
      "h2_subtitle": "The Leila Stockbridge offers spacious 2 bedroom apartments. Nestled in Clayton County, these homes bring comfort and convenience to your doorstep.",
      "page_copy": "Experience the perfect blend of space and style in the 2 bedroom apartments at The Leila Stockbridge, located in Clayton County. Our residences deliver a harmonious living environment with ample room for relaxation and entertainment, enhanced by features such as stainless steel appliances and generous 9' ceilings.\n\nSituated in the vibrant community of Stockbridge, these apartments come with conveniences like in-unit washers and dryers and chic 42\" shaker-style cabinetry that elevates the interior. With the option of detached garages, our community provides functional living solutions to meet your needs. Discover a place where quality meets comfort in the heart of Clayton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Clayton County",
      "seo_description": "Find spacious 2 bedroom apartments in Clayton County at The Leila Stockbridge. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-near-30281",
      "search_query": "3 bedroom apartments near 30281",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 30281",
      "h2_subtitle": "Explore spacious 3 bedroom apartments at The Leila Stockbridge. Located near the 30281 ZIP code, enjoy premium living in a vibrant community.",
      "page_copy": "Discover the expansive comfort of our 3 bedroom apartments at The Leila Stockbridge. Perfectly positioned near the 30281 ZIP code, these homes are designed for those seeking spacious living and a touch of modern elegance. Our residences boast stainless steel appliances, offering a sleek look in the heart of your home.\n\nEach apartment includes high ceilings and stylish 42\" shaker-style cabinetry, enhancing both form and function. With an in-unit washer and dryer and the option for detached garages, our community facilitates a convenient lifestyle. Embrace the vibrant atmosphere of Stockbridge while enjoying roomy interiors that cater to families and roommates alike.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 30281",
      "seo_description": "Explore spacious 3 bedroom apartments near the 30281 area at The Leila Stockbridge. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "apartments-near-clayton-state-university-stockbridge-ga",
      "search_query": "apartments near Clayton State University Stockbridge GA",
      "category": "School",
      "h1_title": "Apartments Near Clayton State University",
      "h2_subtitle": "Find convenient apartments near Clayton State University at The Leila Stockbridge. Located in Stockbridge, GA, enjoy modern living close to campus.",
      "page_copy": "The Leila Stockbridge offers ideal living spaces for students and faculty of Clayton State University, located just a short commute away in Stockbridge, GA. Our apartments blend comfort and modern features, making them perfect for those seeking convenience and style near campus. Unwind in the spacious interiors with amenities like stainless steel appliances and lofty 9' ceilings.\n\nEvery unit comes with an in-unit washer and dryer, simplifying daily chores, while the 42\" shaker-style cabinetry brings a touch of elegance to apartment living. For those with vehicles, detached garages are available, offering secure parking options. Whether you're studying or enjoying what the area has to offer, The Leila Stockbridge is your gateway to a fulfilling university experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clayton State University",
      "seo_description": "Discover apartments near Clayton State University in Stockbridge, GA at The Leila Stockbridge. Enjoy modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-henry-hospital-stockbridge",
      "search_query": "apartments near Piedmont Henry Hospital Stockbridge",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Henry Hospital",
      "h2_subtitle": "Explore The Leila Stockbridge for apartments close to Piedmont Henry Hospital in Stockbridge. Experience convenience and modern living.",
      "page_copy": "For healthcare professionals and those seeking proximity to Piedmont Henry Hospital in Stockbridge, The Leila Stockbridge offers an optimal living choice. Our apartments are designed to suit a modern lifestyle, featuring stainless steel appliances and high ceilings which lend an air of spaciousness and style.\n\nExperience the ease of living with amenities such as an in-unit washer and dryer and elegant 42\" shaker-style cabinetry that elevates the kitchen space. Additionally, the option for detached garages provides secure parking. Located just minutes from Piedmont Henry Hospital, The Leila Stockbridge ensures a convenient commute while providing a serene dwelling with all the comforts you need.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Henry Hospital",
      "seo_description": "Find convenient and modern apartments near Piedmont Henry Hospital in Stockbridge at The Leila Stockbridge. Enjoy ideal proximity and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "apartments-near-clayton-county-park-stockbridge",
      "search_query": "apartments near Clayton County International Park Stockbridge",
      "category": "Park",
      "h1_title": "Apartments Near Clayton County International Park",
      "h2_subtitle": "Find modern living at The Leila Stockbridge, just minutes from Clayton County International Park. Enjoy amenities and proximity in Stockbridge.",
      "page_copy": "For those who love the outdoors and seek proximity to Clayton County International Park, The Leila Stockbridge presents perfect apartment options in Stockbridge. Our community offers contemporary living with features like stainless steel appliances and generous 9’ ceilings, ensuring a stylish and comfortable home.\n\nEnjoy the convenience of included washer and dryer sets within each unit, along with chic 42\" shaker-style cabinetry that enhances the kitchen area. Optional detached garages provide extra storage or parking, catering to diverse needs. Located near Clayton County International Park, The Leila Stockbridge brings the best of recreation and relaxation right at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clayton County International Park",
      "seo_description": "Discover modern apartments near Clayton County International Park in Stockbridge at The Leila Stockbridge. Enjoy amenities and nature proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "stockbridge-ga-apartments-near-village-park-ellenwood",
      "search_query": "Stockbridge GA apartments close to Village Park Ellenwood",
      "category": "Park",
      "h1_title": "Apartments Near Village Park Ellenwood",
      "h2_subtitle": "Discover The Leila Stockbridge, offering apartments close to Village Park Ellenwood. Enjoy modern amenities in Stockbridge, GA.",
      "page_copy": "The Leila Stockbridge provides an inviting residential community perfect for those looking to live near Village Park Ellenwood in Stockbridge, GA. Our apartments are thoughtfully designed with modern comforts like stainless steel appliances and airy 9’ ceilings, creating a welcoming environment.\n\nEach unit comes with a washer and dryer, tailored to meet everyday convenience, and features exquisite 42\" shaker-style cabinetry in the kitchens. For added convenience, detached garages are available. With easy access to Village Park Ellenwood, residents at The Leila Stockbridge can enjoy the perfect balance of recreation and modern living close to vibrant outdoor spaces.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Village Park Ellenwood",
      "seo_description": "Explore The Leila Stockbridge for modern apartments near Village Park Ellenwood in Stockbridge, GA. Enjoy convenient amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167767",
      "source": "custom",
      "page_item_url": "apartments-near-clark-community-park-clayton-county",
      "search_query": "apartments near Clark Community Park Clayton County",
      "category": "Park",
      "h1_title": "Apartments Near Clark Community Park",
      "h2_subtitle": "Live conveniently at The Leila Stockbridge, just a short drive from Clark Community Park in Clayton County. Discover our modern amenities.",
      "page_copy": "Situated in the heart of Stockbridge, GA, The Leila Stockbridge offers a prime location for those seeking apartments near Clark Community Park in Clayton County. Our community boasts modern essentials like stainless steel appliances and expansive 9’ ceilings, ensuring a comfortable living experience.\n\nEnjoy the ease of in-unit washers and dryers and elegant 42\" shaker-style cabinetry that enhances your kitchen's look and functionality. Detached garages are available for added storage or parking needs. Embrace a lifestyle combining convenience and recreation at The Leila Stockbridge, with Clark Community Park just minutes away for your leisure and relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clark Community Park",
      "seo_description": "Find modern apartments near Clark Community Park in Clayton County at The Leila Stockbridge. Enjoy amenities with outdoor proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6080"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671074700"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WDW4MKGD"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script>Object.assign(window, {websiteToken: 'vNz1X8yXonZdQNwGaC7mHuiG', siteConfig: {clt_i: \"102052\", property_id: \"100160106\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "26e27e11f0df1447"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "466252548"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "eb9458a66dce52f3272c"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "3f4c3fd2-e689-11f0-b8e1-fb177cb72388"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4c3fd2-e689-11f0-b8e1-fb177cb72388/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5GNko3WkJLSXhxeGpnSUxLMERSUFE9PSIsInZhbHVlIjoiaWF6NWpGRG8zZmx4bVAzZG4xY20xdz09IiwibWFjIjoiZDhkZTY5YmVlZWI2NzgyMDFiM2UxZjQyZjRlODM4N2I3ZWE3OGZhM2JhOTBkMDE0ZjA2NzkxYmRjNTMxNzBjZSJ9"
    }
  ],
  "custom_qb_id": "6080",
  "custom_repli_id": "11671074700",
  "custom_google_gtm_id": "GTM-WDW4MKGD",
  "custom_entrata_chatbot": "<script>Object.assign(window, {websiteToken: 'vNz1X8yXonZdQNwGaC7mHuiG', siteConfig: {clt_i: \"102052\", property_id: \"100160106\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>",
  "custom_knock_community_id": "26e27e11f0df1447",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "466252548",
  "custom_call_rail_account_hash": "eb9458a66dce52f3272c",
  "custom_eliseai_building_token": "3f4c3fd2-e689-11f0-b8e1-fb177cb72388",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4c3fd2-e689-11f0-b8e1-fb177cb72388/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5GNko3WkJLSXhxeGpnSUxLMERSUFE9PSIsInZhbHVlIjoiaWF6NWpGRG8zZmx4bVAzZG4xY20xdz09IiwibWFjIjoiZDhkZTY5YmVlZWI2NzgyMDFiM2UxZjQyZjRlODM4N2I3ZWE3OGZhM2JhOTBkMDE0ZjA2NzkxYmRjNTMxNzBjZSJ9",
  "custom_audioeye_site_id": "7b9fd671-398b-4e24-9e90-f3e01927ae03",
  "custom_audioeye_site_hash": "c4298eb5ea9270a91e7fdba645fc54cb"
};

export const generatedAt = '2026-10-01T17:22:15.157Z';
